import e, { useState as n, useRef as t, useEffect as o } from "react";
function r(e, n) {
  (null == n || n > e.length) && (n = e.length);
  for (var t = 0, o = Array(n); t < n; t++) o[t] = e[t];
  return o;
}
function i(e, n, t, o, r, i, a) {
  try {
    var l = e[i](a),
      d = l.value;
  } catch (e) {
    return void t(e);
  }
  l.done ? n(d) : Promise.resolve(d).then(o, r);
}
function a(e) {
  return function () {
    var n = this,
      t = arguments;
    return new Promise(function (o, r) {
      var a = e.apply(n, t);
      function l(e) {
        i(a, o, r, l, d, "next", e);
      }
      function d(e) {
        i(a, o, r, l, d, "throw", e);
      }
      l(void 0);
    });
  };
}
function l(e, n, t) {
  return (n = function (e) {
    var n = function (e, n) {
      if ("object" != typeof e || !e) return e;
      var t = e[Symbol.toPrimitive];
      if (void 0 !== t) {
        var o = t.call(e, n || "default");
        if ("object" != typeof o) return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === n ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof n ? n : n + "";
  }(n)) in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function d(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function s(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = null != arguments[n] ? arguments[n] : {};
    n % 2 ? d(Object(t), !0).forEach(function (n) {
      l(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : d(Object(t)).forEach(function (n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function c() {
  c = function c() {
    return n;
  };
  var e,
    n = {},
    t = Object.prototype,
    o = t.hasOwnProperty,
    r = Object.defineProperty || function (e, n, t) {
      e[n] = t.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    l = i.asyncIterator || "@@asyncIterator",
    d = i.toStringTag || "@@toStringTag";
  function s(e, n, t) {
    return Object.defineProperty(e, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[n];
  }
  try {
    s({}, "");
  } catch (e) {
    s = function s(e, n, t) {
      return e[n] = t;
    };
  }
  function u(e, n, t, o) {
    var i = n && n.prototype instanceof v ? n : v,
      a = Object.create(i.prototype),
      l = new N(o || []);
    return r(a, "_invoke", {
      value: L(e, t, l)
    }), a;
  }
  function p(e, n, t) {
    try {
      return {
        type: "normal",
        arg: e.call(n, t)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  n.wrap = u;
  var m = "suspendedStart",
    _ = "suspendedYield",
    f = "executing",
    h = "completed",
    g = {};
  function v() {}
  function y() {}
  function w() {}
  var b = {};
  s(b, a, function () {
    return this;
  });
  var x = Object.getPrototypeOf,
    C = x && x(x(S([])));
  C && C !== t && o.call(C, a) && (b = C);
  var k = w.prototype = v.prototype = Object.create(b);
  function M(e) {
    ["next", "throw", "return"].forEach(function (n) {
      s(e, n, function (e) {
        return this._invoke(n, e);
      });
    });
  }
  function V(e, n) {
    function t(r, i, a, l) {
      var d = p(e[r], e, i);
      if ("throw" !== d.type) {
        var s = d.arg,
          c = s.value;
        return c && "object" == typeof c && o.call(c, "__await") ? n.resolve(c.__await).then(function (e) {
          t("next", e, a, l);
        }, function (e) {
          t("throw", e, a, l);
        }) : n.resolve(c).then(function (e) {
          s.value = e, a(s);
        }, function (e) {
          return t("throw", e, a, l);
        });
      }
      l(d.arg);
    }
    var i;
    r(this, "_invoke", {
      value: function value(e, o) {
        function r() {
          return new n(function (n, r) {
            t(e, o, n, r);
          });
        }
        return i = i ? i.then(r, r) : r();
      }
    });
  }
  function L(n, t, o) {
    var r = m;
    return function (i, a) {
      if (r === f) throw Error("Generator is already running");
      if (r === h) {
        if ("throw" === i) throw a;
        return {
          value: e,
          done: !0
        };
      }
      for (o.method = i, o.arg = a;;) {
        var l = o.delegate;
        if (l) {
          var d = E(l, o);
          if (d) {
            if (d === g) continue;
            return d;
          }
        }
        if ("next" === o.method) o.sent = o._sent = o.arg;else if ("throw" === o.method) {
          if (r === m) throw r = h, o.arg;
          o.dispatchException(o.arg);
        } else "return" === o.method && o.abrupt("return", o.arg);
        r = f;
        var s = p(n, t, o);
        if ("normal" === s.type) {
          if (r = o.done ? h : _, s.arg === g) continue;
          return {
            value: s.arg,
            done: o.done
          };
        }
        "throw" === s.type && (r = h, o.method = "throw", o.arg = s.arg);
      }
    };
  }
  function E(n, t) {
    var o = t.method,
      r = n.iterator[o];
    if (r === e) return t.delegate = null, "throw" === o && n.iterator.return && (t.method = "return", t.arg = e, E(n, t), "throw" === t.method) || "return" !== o && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + o + "' method")), g;
    var i = p(r, n.iterator, t.arg);
    if ("throw" === i.type) return t.method = "throw", t.arg = i.arg, t.delegate = null, g;
    var a = i.arg;
    return a ? a.done ? (t[n.resultName] = a.value, t.next = n.nextLoc, "return" !== t.method && (t.method = "next", t.arg = e), t.delegate = null, g) : a : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, g);
  }
  function j(e) {
    var n = {
      tryLoc: e[0]
    };
    1 in e && (n.catchLoc = e[1]), 2 in e && (n.finallyLoc = e[2], n.afterLoc = e[3]), this.tryEntries.push(n);
  }
  function O(e) {
    var n = e.completion || {};
    n.type = "normal", delete n.arg, e.completion = n;
  }
  function N(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(j, this), this.reset(!0);
  }
  function S(n) {
    if (n || "" === n) {
      var t = n[a];
      if (t) return t.call(n);
      if ("function" == typeof n.next) return n;
      if (!isNaN(n.length)) {
        var r = -1,
          i = function t() {
            for (; ++r < n.length;) if (o.call(n, r)) return t.value = n[r], t.done = !1, t;
            return t.value = e, t.done = !0, t;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof n + " is not iterable");
  }
  return y.prototype = w, r(k, "constructor", {
    value: w,
    configurable: !0
  }), r(w, "constructor", {
    value: y,
    configurable: !0
  }), y.displayName = s(w, d, "GeneratorFunction"), n.isGeneratorFunction = function (e) {
    var n = "function" == typeof e && e.constructor;
    return !!n && (n === y || "GeneratorFunction" === (n.displayName || n.name));
  }, n.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, w) : (e.__proto__ = w, s(e, d, "GeneratorFunction")), e.prototype = Object.create(k), e;
  }, n.awrap = function (e) {
    return {
      __await: e
    };
  }, M(V.prototype), s(V.prototype, l, function () {
    return this;
  }), n.AsyncIterator = V, n.async = function (e, t, o, r, i) {
    void 0 === i && (i = Promise);
    var a = new V(u(e, t, o, r), i);
    return n.isGeneratorFunction(t) ? a : a.next().then(function (e) {
      return e.done ? e.value : a.next();
    });
  }, M(k), s(k, d, "Generator"), s(k, a, function () {
    return this;
  }), s(k, "toString", function () {
    return "[object Generator]";
  }), n.keys = function (e) {
    var n = Object(e),
      t = [];
    for (var o in n) t.push(o);
    return t.reverse(), function e() {
      for (; t.length;) {
        var o = t.pop();
        if (o in n) return e.value = o, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, n.values = S, N.prototype = {
    constructor: N,
    reset: function reset(n) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(O), !n) for (var t in this) "t" === t.charAt(0) && o.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = e);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(n) {
      if (this.done) throw n;
      var t = this;
      function r(o, r) {
        return l.type = "throw", l.arg = n, t.next = o, r && (t.method = "next", t.arg = e), !!r;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var a = this.tryEntries[i],
          l = a.completion;
        if ("root" === a.tryLoc) return r("end");
        if (a.tryLoc <= this.prev) {
          var d = o.call(a, "catchLoc"),
            s = o.call(a, "finallyLoc");
          if (d && s) {
            if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
            if (this.prev < a.finallyLoc) return r(a.finallyLoc);
          } else if (d) {
            if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
          } else {
            if (!s) throw Error("try statement without catch or finally");
            if (this.prev < a.finallyLoc) return r(a.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, n) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var r = this.tryEntries[t];
        if (r.tryLoc <= this.prev && o.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
          var i = r;
          break;
        }
      }
      i && ("break" === e || "continue" === e) && i.tryLoc <= n && n <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = e, a.arg = n, i ? (this.method = "next", this.next = i.finallyLoc, g) : this.complete(a);
    },
    complete: function complete(e, n) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && n && (this.next = n), g;
    },
    finish: function finish(e) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var t = this.tryEntries[n];
        if (t.finallyLoc === e) return this.complete(t.completion, t.afterLoc), O(t), g;
      }
    },
    catch: function _catch(e) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var t = this.tryEntries[n];
        if (t.tryLoc === e) {
          var o = t.completion;
          if ("throw" === o.type) {
            var r = o.arg;
            O(t);
          }
          return r;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(n, t, o) {
      return this.delegate = {
        iterator: S(n),
        resultName: t,
        nextLoc: o
      }, "next" === this.method && (this.arg = e), g;
    }
  }, n;
}
function u(e, n) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, n) {
    var t = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != t) {
      var o,
        r,
        i,
        a,
        l = [],
        d = !0,
        s = !1;
      try {
        if (i = (t = t.call(e)).next, 0 === n) {
          if (Object(t) !== t) return;
          d = !1;
        } else for (; !(d = (o = i.call(t)).done) && (l.push(o.value), l.length !== n); d = !0);
      } catch (e) {
        s = !0, r = e;
      } finally {
        try {
          if (!d && null != t.return && (a = t.return(), Object(a) !== a)) return;
        } finally {
          if (s) throw r;
        }
      }
      return l;
    }
  }(e, n) || m(e, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function p(e) {
  return function (e) {
    if (Array.isArray(e)) return r(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || m(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function m(e, n) {
  if (e) {
    if ("string" == typeof e) return r(e, n);
    var t = {}.toString.call(e).slice(8, -1);
    return "Object" === t && e.constructor && (t = e.constructor.name), "Map" === t || "Set" === t ? Array.from(e) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? r(e, n) : void 0;
  }
}
var _ = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function f(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var h = Array.prototype.slice,
  g = function g(e, n) {
    "length" in e || (e = [e]);
    e = h.call(e);
    for (; e.length;) {
      var t = e.shift(),
        o = n(t);
      if (o) return o;
      t.childNodes && t.childNodes.length && (e = h.call(t.childNodes).concat(e));
    }
  };
var v = y;
function y(e, n) {
  if (!(this instanceof y)) return new y(e, n);
  this.data = e, this.nodeValue = e, this.length = e.length, this.ownerDocument = n || null;
}
y.prototype.nodeType = 8, y.prototype.nodeName = "#comment", y.prototype.toString = function () {
  return "[object Comment]";
};
var w = b;
function b(e, n) {
  if (!(this instanceof b)) return new b(e);
  this.data = e || "", this.length = this.data.length, this.ownerDocument = n || null;
}
b.prototype.type = "DOMTextNode", b.prototype.nodeType = 3, b.prototype.nodeName = "#text", b.prototype.toString = function () {
  return this.data;
}, b.prototype.replaceData = function (e, n, t) {
  var o = this.data,
    r = o.substring(0, e),
    i = o.substring(e + n, o.length);
  this.data = r + t + i, this.length = this.data.length;
};
var x = function x(e) {
  var n = this,
    t = e.type;
  e.target || (e.target = n);
  n.listeners || (n.listeners = {});
  var o = n.listeners[t];
  if (o) return o.forEach(function (t) {
    e.currentTarget = n, "function" == typeof t ? t(e) : t.handleEvent(e);
  });
  n.parentNode && n.parentNode.dispatchEvent(e);
};
var C = function C(e, n) {
  var t = this;
  t.listeners || (t.listeners = {});
  t.listeners[e] || (t.listeners[e] = []);
  -1 === t.listeners[e].indexOf(n) && t.listeners[e].push(n);
};
var k = function k(e, n) {
  var t = this;
  if (!t.listeners) return;
  if (!t.listeners[e]) return;
  var o = t.listeners[e],
    r = o.indexOf(n);
  -1 !== r && o.splice(r, 1);
};
var M = ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "menuitem", "meta", "param", "source", "track", "wbr"];
function V(e) {
  switch (e.nodeType) {
    case 3:
      return j(e.data);
    case 8:
      return "\x3c!--" + e.data + "--\x3e";
    default:
      return function (e) {
        var n = [],
          t = e.tagName;
        "http://www.w3.org/1999/xhtml" === e.namespaceURI && (t = t.toLowerCase());
        n.push("<" + t + function (e) {
          var n = [];
          for (var t in e) L(e, t) && n.push({
            name: t,
            value: e[t]
          });
          for (var o in e._attributes) for (var r in e._attributes[o]) {
            var i = e._attributes[o][r],
              a = (i.prefix ? i.prefix + ":" : "") + r;
            n.push({
              name: a,
              value: i.value
            });
          }
          e.className && n.push({
            name: "class",
            value: e.className
          });
          return n.length ? E(n) : "";
        }(e) + function (e) {
          var n = e.dataset,
            t = [];
          for (var o in n) t.push({
            name: "data-" + o,
            value: n[o]
          });
          return t.length ? E(t) : "";
        }(e)), M.indexOf(t) > -1 ? n.push(" />") : (n.push(">"), e.childNodes.length ? n.push.apply(n, e.childNodes.map(V)) : e.textContent || e.innerText ? n.push(j(e.textContent || e.innerText)) : e.innerHTML && n.push(e.innerHTML), n.push("</" + t + ">"));
        return n.join("");
      }(e);
  }
}
function L(e, n) {
  var t = typeof e[n];
  return "style" === n && Object.keys(e.style).length > 0 || e.hasOwnProperty(n) && ("string" === t || "boolean" === t || "number" === t) && "nodeName" !== n && "className" !== n && "tagName" !== n && "textContent" !== n && "innerText" !== n && "namespaceURI" !== n && "innerHTML" !== n;
}
function E(e) {
  var n = [];
  return e.forEach(function (e) {
    var t = e.name,
      o = e.value;
    "style" === t && (o = function (e) {
      if ("string" == typeof e) return e;
      var n = "";
      return Object.keys(e).forEach(function (t) {
        var o = e[t];
        t = t.replace(/[A-Z]/g, function (e) {
          return "-" + e.toLowerCase();
        }), n += t + ":" + o + ";";
      }), n;
    }(o)), n.push(t + '="' + (j(o).replace(/"/g, "&quot;") + '"'));
  }), n.length ? " " + n.join(" ") : "";
}
function j(e) {
  var n = "";
  return "string" == typeof e ? n = e : e && (n = e.toString()), n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
var O = g,
  N = x,
  S = C,
  I = k,
  D = V,
  B = "http://www.w3.org/1999/xhtml",
  T = P;
function P(e, n, t) {
  if (!(this instanceof P)) return new P(e);
  var o = void 0 === t ? B : t || null;
  this.tagName = o === B ? String(e).toUpperCase() : e, this.nodeName = this.tagName, this.className = "", this.dataset = {}, this.childNodes = [], this.parentNode = null, this.style = {}, this.ownerDocument = n || null, this.namespaceURI = o, this._attributes = {}, "INPUT" === this.tagName && (this.type = "text");
}
P.prototype.type = "DOMElement", P.prototype.nodeType = 1, P.prototype.appendChild = function (e) {
  return e.parentNode && e.parentNode.removeChild(e), this.childNodes.push(e), e.parentNode = this, e;
}, P.prototype.replaceChild = function (e, n) {
  e.parentNode && e.parentNode.removeChild(e);
  var t = this.childNodes.indexOf(n);
  return n.parentNode = null, this.childNodes[t] = e, e.parentNode = this, n;
}, P.prototype.removeChild = function (e) {
  var n = this.childNodes.indexOf(e);
  return this.childNodes.splice(n, 1), e.parentNode = null, e;
}, P.prototype.insertBefore = function (e, n) {
  e.parentNode && e.parentNode.removeChild(e);
  var t = null == n ? -1 : this.childNodes.indexOf(n);
  return t > -1 ? this.childNodes.splice(t, 0, e) : this.childNodes.push(e), e.parentNode = this, e;
}, P.prototype.setAttributeNS = function (e, n, t) {
  var o = null,
    r = n,
    i = n.indexOf(":");
  (i > -1 && (o = n.substr(0, i), r = n.substr(i + 1)), "INPUT" === this.tagName && "type" === n) ? this.type = t : (this._attributes[e] || (this._attributes[e] = {}))[r] = {
    value: t,
    prefix: o
  };
}, P.prototype.getAttributeNS = function (e, n) {
  var t = this._attributes[e],
    o = t && t[n] && t[n].value;
  return "INPUT" === this.tagName && "type" === n ? this.type : "string" != typeof o ? null : o;
}, P.prototype.removeAttributeNS = function (e, n) {
  var t = this._attributes[e];
  t && delete t[n];
}, P.prototype.hasAttributeNS = function (e, n) {
  var t = this._attributes[e];
  return !!t && n in t;
}, P.prototype.setAttribute = function (e, n) {
  return this.setAttributeNS(null, e, n);
}, P.prototype.getAttribute = function (e) {
  return this.getAttributeNS(null, e);
}, P.prototype.removeAttribute = function (e) {
  return this.removeAttributeNS(null, e);
}, P.prototype.hasAttribute = function (e) {
  return this.hasAttributeNS(null, e);
}, P.prototype.removeEventListener = I, P.prototype.addEventListener = S, P.prototype.dispatchEvent = N, P.prototype.focus = function () {}, P.prototype.toString = function () {
  return D(this);
}, P.prototype.getElementsByClassName = function (e) {
  var n = e.split(" "),
    t = [];
  return O(this, function (e) {
    if (1 === e.nodeType) {
      var o = (e.className || "").split(" ");
      n.every(function (e) {
        return -1 !== o.indexOf(e);
      }) && t.push(e);
    }
  }), t;
}, P.prototype.getElementsByTagName = function (e) {
  e = e.toLowerCase();
  var n = [];
  return O(this.childNodes, function (t) {
    1 !== t.nodeType || "*" !== e && t.tagName.toLowerCase() !== e || n.push(t);
  }), n;
}, P.prototype.contains = function (e) {
  return O(this, function (n) {
    return e === n;
  }) || !1;
};
var A = T,
  F = R;
function R(e) {
  if (!(this instanceof R)) return new R();
  this.childNodes = [], this.parentNode = null, this.ownerDocument = e || null;
}
R.prototype.type = "DocumentFragment", R.prototype.nodeType = 11, R.prototype.nodeName = "#document-fragment", R.prototype.appendChild = A.prototype.appendChild, R.prototype.replaceChild = A.prototype.replaceChild, R.prototype.removeChild = A.prototype.removeChild, R.prototype.toString = function () {
  return this.childNodes.map(function (e) {
    return String(e);
  }).join("");
};
var H = z;
function z(e) {}
z.prototype.initEvent = function (e, n, t) {
  this.type = e, this.bubbles = n, this.cancelable = t;
}, z.prototype.preventDefault = function () {};
var Z = g,
  U = v,
  $ = w,
  Y = T,
  q = F,
  G = H,
  J = x,
  W = C,
  K = k,
  Q = X;
function X() {
  if (!(this instanceof X)) return new X();
  this.head = this.createElement("head"), this.body = this.createElement("body"), this.documentElement = this.createElement("html"), this.documentElement.appendChild(this.head), this.documentElement.appendChild(this.body), this.childNodes = [this.documentElement], this.nodeType = 9;
}
var ee = X.prototype;
ee.createTextNode = function (e) {
  return new $(e, this);
}, ee.createElementNS = function (e, n) {
  var t = null === e ? null : String(e);
  return new Y(n, this, t);
}, ee.createElement = function (e) {
  return new Y(e, this);
}, ee.createDocumentFragment = function () {
  return new q(this);
}, ee.createEvent = function (e) {
  return new G();
}, ee.createComment = function (e) {
  return new U(e, this);
}, ee.getElementById = function (e) {
  return e = String(e), Z(this.childNodes, function (n) {
    if (String(n.id) === e) return n;
  }) || null;
}, ee.getElementsByClassName = Y.prototype.getElementsByClassName, ee.getElementsByTagName = Y.prototype.getElementsByTagName, ee.contains = Y.prototype.contains, ee.removeEventListener = K, ee.addEventListener = W, ee.dispatchEvent = J;
var ne,
  te = new Q(),
  oe = void 0 !== _ ? _ : "undefined" != typeof window ? window : {},
  re = te;
"undefined" != typeof document ? ne = document : (ne = oe["__GLOBAL_DOCUMENT_CACHE@4"]) || (ne = oe["__GLOBAL_DOCUMENT_CACHE@4"] = re);
var ie = f(ne),
  ae = f("undefined" != typeof window ? window : void 0 !== _ ? _ : "undefined" != typeof self ? self : {});
/*! @name @brightcove/react-player-loader @version 1.5.0 @license Apache-2.0 */
function le() {
  return le = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, le.apply(this, arguments);
}
/*! @name @brightcove/player-loader @version 1.8.0 @license Apache-2.0 */
function de() {
  return de = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, de.apply(this, arguments);
}
var se = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
  ce = ["catalogSearch", "catalogSequence"],
  ue = ["adConfigId", "applicationId", "catalogSearch", "catalogSequence", "playlistId", "playlistVideoId", "videoId"],
  pe = function pe(e) {
    return Object.keys(e).filter(function (e) {
      return -1 !== ue.indexOf(e);
    }).reduce(function (n, t) {
      var o = function (e, n) {
        if (e && void 0 !== e[n]) {
          if ("string" != typeof e[n] && -1 !== ce.indexOf(n)) try {
            return encodeURIComponent(JSON.stringify(e[n]));
          } catch (e) {
            return;
          }
          return encodeURIComponent(String(e[n]).trim()) || void 0;
        }
      }(e, t);
      return void 0 !== o && (n += n ? "&" : "?", n += encodeURIComponent(t) + "=" + o), n;
    }, "");
  },
  me = function me(e) {
    var n = e.accountId,
      t = e.base,
      o = void 0 === t ? "https://players.brightcove.net" : t,
      r = e.playerId,
      i = void 0 === r ? "default" : r,
      a = e.embedId,
      l = void 0 === a ? "default" : a,
      d = e.iframe,
      s = void 0 !== d && d,
      c = e.minified,
      u = void 0 === c || c,
      p = e.queryParams,
      m = void 0 === p ? null : p,
      _ = "";
    s ? _ += "html" : (u && (_ += "min."), _ += "js"), "/" === o.charAt(o.length - 1) && (o = o.substring(0, o.length - 1));
    var f = "";
    return s && m && "object" === (void 0 === m ? "undefined" : se(m)) && (f = pe(m)), o + "/" + (n = encodeURIComponent(n)) + "/" + (i = encodeURIComponent(i)) + "_" + (l = encodeURIComponent(l)) + "/index." + _ + f;
  };
/*! @name @brightcove/player-url @version 1.2.0 @license Apache-2.0 */
me.VERSION = "1.2.0";
var _e = {
    embedId: "default",
    embedType: "in-page",
    playerId: "default",
    Promise: ae.Promise,
    refNodeInsert: "append"
  },
  fe = "video",
  he = "video-js",
  ge = "in-page",
  ve = "iframe",
  ye = "append",
  we = "prepend",
  be = "before",
  xe = "after",
  Ce = "replace",
  ke = ["catalogSearch", "catalogSequence"],
  Me = "https://players.brightcove.net/",
  Ve = function Ve(e) {
    if (e.playerUrl) return e.playerUrl;
    var n = e.accountId,
      t = e.playerId,
      o = e.embedId,
      r = e.embedOptions,
      i = e.embedType === ve;
    return me({
      accountId: n,
      playerId: t,
      embedId: o,
      iframe: i,
      base: Me,
      minified: !r || !r.unminified,
      queryParams: e
    });
  },
  Le = function Le() {
    return Me;
  },
  Ee = function Ee(e) {
    Me = e;
  },
  je = function je(e) {
    return Boolean(e && 1 === e.nodeType);
  },
  Oe = function Oe(e) {
    return Boolean(je(e) && e.parentNode);
  },
  Ne = function Ne(e, n, t) {
    return n ? function (e, n) {
      if (!e.pip) return n;
      var t = ie.createElement("div");
      return t.classList.add("vjs-pip-container"), t.appendChild(n), t;
    }(n, function (e, n, t) {
      if (!n.responsive) return t;
      t.style.position = "absolute", t.style.top = "0px", t.style.right = "0px", t.style.bottom = "0px", t.style.left = "0px", t.style.width = "100%", t.style.height = "100%";
      var o = de({
          aspectRatio: "16:9",
          iframeHorizontalPlaylist: !1,
          maxWidth: "100%"
        }, n.responsive),
        r = o.aspectRatio.split(":").map(Number),
        i = ie.createElement("div"),
        a = r[1] / r[0] * 100;
      e === ve && o.iframeHorizontalPlaylist && (a *= 1.25), i.style.paddingTop = a + "%", i.appendChild(t);
      var l = ie.createElement("div");
      return l.style.position = "relative", l.style.display = "block", l.style.maxWidth = o.maxWidth, l.appendChild(i), l;
    }(e, n, t)) : t;
  },
  Se = function Se(e) {
    var n = e.embedType === ve ? function (e) {
      var n = ie.createElement("iframe");
      return n.setAttribute("allow", "autoplay;encrypted-media;fullscreen"), n.setAttribute("allowfullscreen", "allowfullscreen"), n.src = Ve(e), n;
    }(e) : function (e) {
      var n = e.embedOptions,
        t = {
          adConfigId: "data-ad-config-id",
          applicationId: "data-application-id",
          catalogSearch: "data-catalog-search",
          catalogSequence: "data-catalog-sequence",
          deliveryConfigId: "data-delivery-config-id",
          playlistId: "data-playlist-id",
          playlistVideoId: "data-playlist-video-id",
          poster: "poster",
          videoId: "data-video-id"
        },
        o = n && n.tagName || he,
        r = ie.createElement(o);
      return Object.keys(t).filter(function (n) {
        return e[n];
      }).forEach(function (n) {
        var o;
        if ("string" != typeof e[n] && -1 !== ke.indexOf(n)) try {
          o = JSON.stringify(e[n]);
        } catch (e) {
          return;
        } else o = String(e[n]).trim();
        r.setAttribute(t[n], o);
      }), r.setAttribute("controls", "controls"), r.classList.add("video-js"), r;
    }(e);
    return function (e, n) {
      var t = e.refNode,
        o = e.refNodeInsert,
        r = t.parentNode,
        i = Ne(e.embedType, e.embedOptions, n);
      if (o === be ? r.insertBefore(i, t) : o === xe ? r.insertBefore(i, t.nextElementSibling || null) : o === Ce ? r.replaceChild(i, t) : o === we ? t.insertBefore(i, t.firstChild || null) : t.appendChild(i), e.embedOptions && e.embedOptions.playlist) {
        var a = e.embedOptions.playlist.legacy ? "ul" : "div",
          l = ie.createElement(a);
        l.classList.add("vjs-playlist"), n.parentNode.insertBefore(l, n.nextElementSibling || null);
      }
      return e.refNode = null, n;
    }(e, function (e, n) {
      if ("function" != typeof e.onEmbedCreated) return n;
      var t = e.onEmbedCreated(n);
      return je(t) ? t : n;
    }(e, n));
  },
  Ie = new ae.Map(),
  De = function De(e) {
    return (e.accountId || "*") + "_" + e.playerId + "_" + e.embedId;
  },
  Be = function Be() {
    Ie.clear();
  },
  Te = function Te(e) {
    Ie.forEach(e);
  },
  Pe = function Pe(e) {
    return Ie.has(De(e));
  },
  Ae = function Ae(e) {
    Ie.set(De(e), e.accountId ? Ve(e) : "");
  },
  Fe = /^([A-Za-z0-9]+)_([A-Za-z0-9]+)$/,
  Re = function Re() {
    return ae.bc ? Object.keys(ae.bc).filter(function (e) {
      return Fe.test(e);
    }) : [];
  },
  He = function He(e) {
    e && Object.keys(e.players).forEach(function (n) {
      var t = e.players[n];
      t && t.dispose();
    });
  },
  ze = function ze() {
    Te(function (e, n) {
      e && Array.prototype.slice.call(ie.querySelectorAll('script[src="' + e + '"]')).forEach(function (e) {
        return e.parentNode.removeChild(e);
      });
    }), Be(), He(ae.videojs), Re().forEach(function (e) {
      return He(ae.bc[e].videojs);
    }), Object.keys(ae).filter(function (e) {
      return /^videojs/i.test(e) || /^(bc)$/.test(e);
    }).forEach(function (e) {
      delete ae[e];
    });
  };
(function () {
  Re().forEach(function (e) {
    var n = e.match(Fe),
      t = {
        playerId: n[1],
        embedId: n[2]
      };
    Pe(t) || Ae(t);
  });
})();
var Ze = function Ze(e) {
    return "function" == typeof e;
  },
  Ue = function Ue(e) {
    var n,
      t = e.accountId,
      o = e.embedOptions,
      r = e.embedType,
      i = e.options,
      a = e.refNode,
      l = e.refNodeInsert;
    if (!t) throw new Error("accountId is required");
    if (!Oe(a)) throw new Error("refNode must resolve to a node attached to the DOM");
    if (!function (e) {
      return e === ge || e === ve;
    }(r)) throw new Error("embedType is missing or invalid");
    if (r === ve && i) throw new Error("cannot use options with an iframe embed");
    if (o && void 0 !== o.tagName && (n = o.tagName) !== he && n !== fe) throw new Error('embedOptions.tagName is invalid (value: "' + o.tagName + '")');
    if (o && o.responsive && o.responsive.aspectRatio && !/^\d+\:\d+$/.test(o.responsive.aspectRatio)) throw new Error('embedOptions.responsive.aspectRatio must be in the "n:n" format (value: "' + o.responsive.aspectRatio + '")');
    if (!function (e) {
      return e === ye || e === we || e === be || e === xe || e === Ce;
    }(l)) throw new Error("refNodeInsert is missing or invalid");
  },
  $e = function $e(e, n, t, o) {
    var r,
      i = e.embedId,
      a = e.playerId,
      l = ae.bc[a + "_" + i] || ae.bc;
    if (!l) return o(new Error("missing bc function for " + a));
    Ae(e);
    try {
      (r = l(n, e.options)).bcinfo && (r.bcinfo.PLAYER_LOADER = !0);
    } catch (n) {
      var d = "Could not initialize the Brightcove Player.";
      return e.embedOptions.tagName === he && (d += ' You are attempting to embed using a "video-js" element. Please ensure that your Player is v6.11.0 or newer in order to support this embed type. Alternatively, pass `"video"` for `embedOptions.tagName`.'), o(new Error(d));
    }
    t({
      type: ge,
      ref: r
    });
  },
  Ye = function Ye(e, n, t) {
    e.refNode = function (e) {
      return Oe(e) ? e : "string" == typeof e ? ie.querySelector(e) : null;
    }(e.refNode), Ue(e);
    var o = e.refNode,
      r = e.refNodeInsert,
      i = o.parentNode,
      a = Se(e);
    if (e.embedType !== ve) {
      if (Pe(e)) return $e(e, a, n, t);
      var l = ie.createElement("script");
      l.onload = function () {
        return $e(e, a, n, t);
      }, l.onerror = function () {
        t(new Error("player script could not be downloaded"));
      }, l.async = !0, l.charset = "utf-8", l.src = Ve(e), r === Ce ? i.appendChild(l) : o.appendChild(l);
    } else n({
      type: ve,
      ref: a
    });
  },
  qe = function qe(e) {
    var n = de({}, _e, e),
      t = n.Promise,
      o = n.onSuccess,
      r = n.onFailure;
    return !Ze(t) || Ze(o) || Ze(r) ? Ye(n, Ze(o) ? o : function () {}, Ze(r) ? r : function (e) {
      throw e;
    }) : new t(function (e, t) {
      return Ye(n, e, t);
    });
  },
  Ge = function Ge(e, n) {
    Object.defineProperty(qe, e, {
      configurable: !1,
      enumerable: !0,
      value: n,
      writable: !1
    });
  };
Ge("getBaseUrl", function () {
  return Le();
}), Ge("setBaseUrl", function (e) {
  Ee(e);
}), Ge("getUrl", function (e) {
  return Ve(e);
}), Ge("reset", function () {
  return ze();
}), [["EMBED_TAG_NAME_VIDEO", fe], ["EMBED_TAG_NAME_VIDEOJS", he], ["EMBED_TYPE_IN_PAGE", ge], ["EMBED_TYPE_IFRAME", ve], ["REF_NODE_INSERT_APPEND", ye], ["REF_NODE_INSERT_PREPEND", we], ["REF_NODE_INSERT_BEFORE", be], ["REF_NODE_INSERT_AFTER", xe], ["REF_NODE_INSERT_REPLACE", Ce], ["VERSION", "1.8.0"]].forEach(function (e) {
  Ge(e[0], e[1]);
});
var Je,
  We = ["catalogSearch", "catalogSequence", "playlistId", "playlistVideoId", "videoId"],
  Ke = function (n) {
    var t, o;
    function r(e) {
      var t;
      return (t = n.call(this, e) || this).refNode = null, t.setRefNode = function (e) {
        t.refNode = e;
      }, t.loadPlayer = t.loadPlayer.bind(function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(t)), t;
    }
    o = n, (t = r).prototype = Object.create(o.prototype), t.prototype.constructor = t, t.__proto__ = o;
    var i = r.prototype;
    return i.loadPlayer = function () {
      var e = this;
      if (this.loading_) console.log("Brightcove React Player Loader aborted a subsequent player load while a load was pending");else {
        this.loading_ = !0, this.disposePlayer();
        var n = this.props.onSuccess,
          t = this.props.onFailure,
          o = le({}, this.props, {
            refNode: this.refNode,
            refNodeInsert: "append",
            onSuccess: function onSuccess(t) {
              var o = t.ref,
                r = t.type;
              e.loading_ = !1, e.isMounted_ ? (e.player = o, "in-page" === r && o.one("dispose", function () {
                e.player = null;
              }), o.bcinfo && (o.bcinfo.REACT_PLAYER_LOADER = !0), "function" == typeof n && n({
                ref: o,
                type: r
              })) : e.disposePlayer(o);
            },
            onFailure: function onFailure(n) {
              if (e.loading_ = !1, e.isMounted_) {
                if ("function" != typeof t) throw new Error(n);
                t(n);
              }
            }
          });
        delete o.attrs, delete o.baseUrl, delete o.manualReloadFromPropChanges;
        var r = qe.getBaseUrl();
        this.props.baseUrl && qe.setBaseUrl(this.props.baseUrl), qe(o), qe.setBaseUrl(r);
      }
    }, i.disposePlayer = function () {
      this.player && (this.player.dispose ? this.player.dispose() : this.player.parentNode && this.player.parentNode.removeChild(this.player), this.player = null);
    }, i.findPlaylistVideoIdIndex_ = function (e) {
      var n = this.props.playlistVideoId;
      if (Array.isArray(e) && n) for (var t = 0; t < e.length; t++) {
        var o = e[t],
          r = o.id,
          i = o.referenceId;
        if (r === n || "ref:" + i === n) return t;
      }
      return -1;
    }, i.createPlaybackAPICallback_ = function (e, n) {
      var t = this;
      return function (o, r) {
        if (o) !function (e) {
          e && console && console.error && console.error(e);
        }(o);else {
          if ("playlist" === e && n.playlistVideoId) {
            var i = t.findPlaylistVideoIdIndex_(r);
            i > -1 && (r.startingIndex = i);
          }
          t.player.catalog.load(r);
        }
      };
    }, i.updatePlayer = function (e) {
      if (this.player && this.player.el && this.player.el()) {
        var n;
        if (this.player.usingPlugin("catalog")) {
          if (e.catalogSequence && this.props.catalogSequence) {
            var t = this.createPlaybackAPICallback_("sequence", e);
            return void this.player.catalog.getLazySequence(this.props.catalogSequence, t, this.props.adConfigId);
          }
          e.videoId && this.props.videoId ? n = {
            type: "video",
            id: this.props.videoId
          } : e.playlistId && this.props.playlistId ? n = {
            type: "playlist",
            id: this.props.playlistId
          } : e.catalogSearch && this.props.catalogSearch && (n = {
            type: "search",
            q: this.props.catalogSearch
          });
        }
        if (n) {
          this.props.adConfigId && (n.adConfigId = this.props.adConfigId), this.props.deliveryConfigId && (n.deliveryConfigId = this.props.deliveryConfigId);
          var o = this.createPlaybackAPICallback_(n.type, e);
          this.player.catalog.get(n, o);
        } else if (e.playlistVideoId && this.props.playlistVideoId && this.player.usingPlugin("playlist")) {
          var r = this.findPlaylistVideoIdIndex_(this.player.playlist());
          r > -1 && this.player.playlist.currentItem(r);
        }
      }
    }, i.componentDidMount = function () {
      this.isMounted_ = !0, this.loadPlayer();
    }, i.componentDidUpdate = function (e) {
      var n = this,
        t = Object.keys(e).reduce(function (t, o) {
          var r = e[o],
            i = n.props[o];
          return "function" == typeof i ? t : "object" == typeof i && null !== i ? (JSON.stringify(i) !== JSON.stringify(r) && (t[o] = !0), t) : (i !== r && (t[o] = !0), t);
        }, {});
      this.props.manualReloadFromPropChanges || !Object.keys(t).some(function (e) {
        return -1 === We.indexOf(e);
      }) ? this.updatePlayer(t) : this.loadPlayer();
    }, i.componentWillUnmount = function () {
      this.isMounted_ = !1, this.disposePlayer();
    }, i.render = function () {
      var n = le({
        className: "brightcove-react-player-loader"
      }, this.props.attrs, {
        ref: this.setRefNode
      });
      return e.createElement("div", n);
    }, r;
  }(e.Component),
  Qe = {
    exports: {}
  },
  Xe = f(Qe.exports = function () {
    var e = function e() {},
      n = {},
      t = {},
      o = {};
    function r(e, n) {
      e = e.push ? e : [e];
      var r,
        i,
        a,
        l = [],
        d = e.length,
        s = d;
      for (r = function r(e, t) {
        t.length && l.push(e), --s || n(l);
      }; d--;) i = e[d], (a = t[i]) ? r(i, a) : (o[i] = o[i] || []).push(r);
    }
    function i(e, n) {
      if (e) {
        var r = o[e];
        if (t[e] = n, r) for (; r.length;) r[0](e, n), r.splice(0, 1);
      }
    }
    function a(n, t) {
      n.call && (n = {
        success: n
      }), t.length ? (n.error || e)(t) : (n.success || e)(n);
    }
    function l(n, t, o, r) {
      var i,
        a,
        d,
        s = document,
        c = o.async,
        u = (o.numRetries || 0) + 1,
        p = o.before || e,
        m = n.replace(/[\?|#].*$/, ""),
        _ = n.replace(/^(css|img|module|nomodule)!/, "");
      if (r = r || 0, /(^css!|\.css$)/.test(m)) (d = s.createElement("link")).rel = "stylesheet", d.href = _, (i = "hideFocus" in d) && d.relList && (i = 0, d.rel = "preload", d.as = "style");else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(m)) (d = s.createElement("img")).src = _;else if ((d = s.createElement("script")).src = _, d.async = void 0 === c || c, a = "noModule" in d, /^module!/.test(m)) {
        if (!a) return t(n, "l");
        d.type = "module";
      } else if (/^nomodule!/.test(m) && a) return t(n, "l");
      d.onload = d.onerror = d.onbeforeload = function (e) {
        var a = e.type[0];
        if (i) try {
          d.sheet.cssText.length || (a = "e");
        } catch (e) {
          18 != e.code && (a = "e");
        }
        if ("e" == a) {
          if ((r += 1) < u) return l(n, t, o, r);
        } else if ("preload" == d.rel && "style" == d.as) return d.rel = "stylesheet";
        t(n, a, e.defaultPrevented);
      }, !1 !== p(n, d) && s.head.appendChild(d);
    }
    function d(e, n, t) {
      var o,
        r,
        i = (e = e.push ? e : [e]).length,
        a = i,
        d = [];
      for (o = function o(e, t, _o) {
        if ("e" == t && d.push(e), "b" == t) {
          if (!_o) return;
          d.push(e);
        }
        --i || n(d);
      }, r = 0; r < a; r++) l(e[r], o, t);
    }
    function s(e, t, o) {
      var r, l;
      if (t && t.trim && (r = t), l = (r ? o : t) || {}, r) {
        if (r in n) throw "LoadJS";
        n[r] = !0;
      }
      function s(n, t) {
        d(e, function (e) {
          a(l, e), n && a({
            success: n,
            error: t
          }, e), i(r, e);
        }, l);
      }
      if (l.returnPromise) return new Promise(s);
      s();
    }
    return s.ready = function (e, n) {
      return r(e, function (e) {
        a(n, e);
      }), s;
    }, s.done = function (e) {
      i(e, []);
    }, s.reset = function () {
      n = {}, t = {}, o = {};
    }, s.isDefined = function (e) {
      return e in n;
    }, s;
  }()),
  en = {
    exports: {}
  },
  nn = {
    exports: {}
  },
  tn = {};
var on,
  rn,
  an,
  ln,
  dn,
  sn,
  cn,
  un,
  pn,
  mn,
  _n,
  fn,
  hn,
  gn,
  vn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function yn() {
  return rn || (rn = 1, "production" === process.env.NODE_ENV ? nn.exports = function () {
    if (Je) return tn;
    Je = 1;
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      t = e ? Symbol.for("react.portal") : 60106,
      o = e ? Symbol.for("react.fragment") : 60107,
      r = e ? Symbol.for("react.strict_mode") : 60108,
      i = e ? Symbol.for("react.profiler") : 60114,
      a = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      d = e ? Symbol.for("react.async_mode") : 60111,
      s = e ? Symbol.for("react.concurrent_mode") : 60111,
      c = e ? Symbol.for("react.forward_ref") : 60112,
      u = e ? Symbol.for("react.suspense") : 60113,
      p = e ? Symbol.for("react.suspense_list") : 60120,
      m = e ? Symbol.for("react.memo") : 60115,
      _ = e ? Symbol.for("react.lazy") : 60116,
      f = e ? Symbol.for("react.block") : 60121,
      h = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      v = e ? Symbol.for("react.scope") : 60119;
    function y(e) {
      if ("object" == typeof e && null !== e) {
        var p = e.$$typeof;
        switch (p) {
          case n:
            switch (e = e.type) {
              case d:
              case s:
              case o:
              case i:
              case r:
              case u:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case l:
                  case c:
                  case _:
                  case m:
                  case a:
                    return e;
                  default:
                    return p;
                }
            }
          case t:
            return p;
        }
      }
    }
    function w(e) {
      return y(e) === s;
    }
    return tn.AsyncMode = d, tn.ConcurrentMode = s, tn.ContextConsumer = l, tn.ContextProvider = a, tn.Element = n, tn.ForwardRef = c, tn.Fragment = o, tn.Lazy = _, tn.Memo = m, tn.Portal = t, tn.Profiler = i, tn.StrictMode = r, tn.Suspense = u, tn.isAsyncMode = function (e) {
      return w(e) || y(e) === d;
    }, tn.isConcurrentMode = w, tn.isContextConsumer = function (e) {
      return y(e) === l;
    }, tn.isContextProvider = function (e) {
      return y(e) === a;
    }, tn.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, tn.isForwardRef = function (e) {
      return y(e) === c;
    }, tn.isFragment = function (e) {
      return y(e) === o;
    }, tn.isLazy = function (e) {
      return y(e) === _;
    }, tn.isMemo = function (e) {
      return y(e) === m;
    }, tn.isPortal = function (e) {
      return y(e) === t;
    }, tn.isProfiler = function (e) {
      return y(e) === i;
    }, tn.isStrictMode = function (e) {
      return y(e) === r;
    }, tn.isSuspense = function (e) {
      return y(e) === u;
    }, tn.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === s || e === i || e === r || e === u || e === p || "object" == typeof e && null !== e && (e.$$typeof === _ || e.$$typeof === m || e.$$typeof === a || e.$$typeof === l || e.$$typeof === c || e.$$typeof === h || e.$$typeof === g || e.$$typeof === v || e.$$typeof === f);
    }, tn.typeOf = y, tn;
  }() : nn.exports = (on || (on = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
      n = e ? Symbol.for("react.element") : 60103,
      t = e ? Symbol.for("react.portal") : 60106,
      o = e ? Symbol.for("react.fragment") : 60107,
      r = e ? Symbol.for("react.strict_mode") : 60108,
      i = e ? Symbol.for("react.profiler") : 60114,
      a = e ? Symbol.for("react.provider") : 60109,
      l = e ? Symbol.for("react.context") : 60110,
      d = e ? Symbol.for("react.async_mode") : 60111,
      s = e ? Symbol.for("react.concurrent_mode") : 60111,
      c = e ? Symbol.for("react.forward_ref") : 60112,
      u = e ? Symbol.for("react.suspense") : 60113,
      p = e ? Symbol.for("react.suspense_list") : 60120,
      m = e ? Symbol.for("react.memo") : 60115,
      _ = e ? Symbol.for("react.lazy") : 60116,
      f = e ? Symbol.for("react.block") : 60121,
      h = e ? Symbol.for("react.fundamental") : 60117,
      g = e ? Symbol.for("react.responder") : 60118,
      v = e ? Symbol.for("react.scope") : 60119;
    function y(e) {
      if ("object" == typeof e && null !== e) {
        var p = e.$$typeof;
        switch (p) {
          case n:
            var f = e.type;
            switch (f) {
              case d:
              case s:
              case o:
              case i:
              case r:
              case u:
                return f;
              default:
                var h = f && f.$$typeof;
                switch (h) {
                  case l:
                  case c:
                  case _:
                  case m:
                  case a:
                    return h;
                  default:
                    return p;
                }
            }
          case t:
            return p;
        }
      }
    }
    var w = d,
      b = s,
      x = l,
      C = a,
      k = n,
      M = c,
      V = o,
      L = _,
      E = m,
      j = t,
      O = i,
      N = r,
      S = u,
      I = !1;
    function D(e) {
      return y(e) === s;
    }
    vn.AsyncMode = w, vn.ConcurrentMode = b, vn.ContextConsumer = x, vn.ContextProvider = C, vn.Element = k, vn.ForwardRef = M, vn.Fragment = V, vn.Lazy = L, vn.Memo = E, vn.Portal = j, vn.Profiler = O, vn.StrictMode = N, vn.Suspense = S, vn.isAsyncMode = function (e) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), D(e) || y(e) === d;
    }, vn.isConcurrentMode = D, vn.isContextConsumer = function (e) {
      return y(e) === l;
    }, vn.isContextProvider = function (e) {
      return y(e) === a;
    }, vn.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, vn.isForwardRef = function (e) {
      return y(e) === c;
    }, vn.isFragment = function (e) {
      return y(e) === o;
    }, vn.isLazy = function (e) {
      return y(e) === _;
    }, vn.isMemo = function (e) {
      return y(e) === m;
    }, vn.isPortal = function (e) {
      return y(e) === t;
    }, vn.isProfiler = function (e) {
      return y(e) === i;
    }, vn.isStrictMode = function (e) {
      return y(e) === r;
    }, vn.isSuspense = function (e) {
      return y(e) === u;
    }, vn.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === o || e === s || e === i || e === r || e === u || e === p || "object" == typeof e && null !== e && (e.$$typeof === _ || e.$$typeof === m || e.$$typeof === a || e.$$typeof === l || e.$$typeof === c || e.$$typeof === h || e.$$typeof === g || e.$$typeof === v || e.$$typeof === f);
    }, vn.typeOf = y;
  }()), vn)), nn.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
function wn() {
  if (ln) return an;
  ln = 1;
  var e = Object.getOwnPropertySymbols,
    n = Object.prototype.hasOwnProperty,
    t = Object.prototype.propertyIsEnumerable;
  return an = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
      for (var n = {}, t = 0; t < 10; t++) n["_" + String.fromCharCode(t)] = t;
      if ("0123456789" !== Object.getOwnPropertyNames(n).map(function (e) {
        return n[e];
      }).join("")) return !1;
      var o = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        o[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, o)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (o, r) {
    for (var i, a, l = function (e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(o), d = 1; d < arguments.length; d++) {
      for (var s in i = Object(arguments[d])) n.call(i, s) && (l[s] = i[s]);
      if (e) {
        a = e(i);
        for (var c = 0; c < a.length; c++) t.call(i, a[c]) && (l[a[c]] = i[a[c]]);
      }
    }
    return l;
  }, an;
}
function bn() {
  if (sn) return dn;
  sn = 1;
  return dn = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}
function xn() {
  return un ? cn : (un = 1, cn = Function.call.bind(Object.prototype.hasOwnProperty));
}
if ("production" !== process.env.NODE_ENV) {
  var Cn = yn();
  en.exports = function () {
    if (fn) return _n;
    fn = 1;
    var e = yn(),
      n = wn(),
      t = bn(),
      o = xn(),
      r = function () {
        if (mn) return pn;
        mn = 1;
        var e = function e() {};
        if ("production" !== process.env.NODE_ENV) {
          var n = bn(),
            t = {},
            o = xn();
          e = function e(_e2) {
            var n = "Warning: " + _e2;
            "undefined" != typeof console && console.error(n);
            try {
              throw new Error(n);
            } catch (e) {}
          };
        }
        function r(r, i, a, l, d) {
          if ("production" !== process.env.NODE_ENV) for (var s in r) if (o(r, s)) {
            var c;
            try {
              if ("function" != typeof r[s]) {
                var u = Error((l || "React class") + ": " + a + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw u.name = "Invariant Violation", u;
              }
              c = r[s](i, s, l, a, null, n);
            } catch (e) {
              c = e;
            }
            if (!c || c instanceof Error || e((l || "React class") + ": type specification of " + a + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), c instanceof Error && !(c.message in t)) {
              t[c.message] = !0;
              var p = d ? d() : "";
              e("Failed " + a + " type: " + c.message + (null != p ? p : ""));
            }
          }
        }
        return r.resetWarningCache = function () {
          "production" !== process.env.NODE_ENV && (t = {});
        }, pn = r;
      }(),
      i = function i() {};
    function a() {
      return null;
    }
    return "production" !== process.env.NODE_ENV && (i = function i(e) {
      var n = "Warning: " + e;
      "undefined" != typeof console && console.error(n);
      try {
        throw new Error(n);
      } catch (e) {}
    }), _n = function _n(l, d) {
      var s = "function" == typeof Symbol && Symbol.iterator,
        c = "<<anonymous>>",
        u = {
          array: f("array"),
          bigint: f("bigint"),
          bool: f("boolean"),
          func: f("function"),
          number: f("number"),
          object: f("object"),
          string: f("string"),
          symbol: f("symbol"),
          any: _(a),
          arrayOf: function arrayOf(e) {
            return _(function (n, o, r, i, a) {
              if ("function" != typeof e) return new m("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
              var l = n[o];
              if (!Array.isArray(l)) return new m("Invalid " + i + " `" + a + "` of type `" + v(l) + "` supplied to `" + r + "`, expected an array.");
              for (var d = 0; d < l.length; d++) {
                var s = e(l, d, r, i, a + "[" + d + "]", t);
                if (s instanceof Error) return s;
              }
              return null;
            });
          },
          element: _(function (e, n, t, o, r) {
            var i = e[n];
            return l(i) ? null : new m("Invalid " + o + " `" + r + "` of type `" + v(i) + "` supplied to `" + t + "`, expected a single ReactElement.");
          }),
          elementType: _(function (n, t, o, r, i) {
            var a = n[t];
            return e.isValidElementType(a) ? null : new m("Invalid " + r + " `" + i + "` of type `" + v(a) + "` supplied to `" + o + "`, expected a single ReactElement type.");
          }),
          instanceOf: function instanceOf(e) {
            return _(function (n, t, o, r, i) {
              if (!(n[t] instanceof e)) {
                var a = e.name || c;
                return new m("Invalid " + r + " `" + i + "` of type `" + ((l = n[t]).constructor && l.constructor.name ? l.constructor.name : c) + "` supplied to `" + o + "`, expected instance of `" + a + "`.");
              }
              var l;
              return null;
            });
          },
          node: _(function (e, n, t, o, r) {
            return g(e[n]) ? null : new m("Invalid " + o + " `" + r + "` supplied to `" + t + "`, expected a ReactNode.");
          }),
          objectOf: function objectOf(e) {
            return _(function (n, r, i, a, l) {
              if ("function" != typeof e) return new m("Property `" + l + "` of component `" + i + "` has invalid PropType notation inside objectOf.");
              var d = n[r],
                s = v(d);
              if ("object" !== s) return new m("Invalid " + a + " `" + l + "` of type `" + s + "` supplied to `" + i + "`, expected an object.");
              for (var c in d) if (o(d, c)) {
                var u = e(d, c, i, a, l + "." + c, t);
                if (u instanceof Error) return u;
              }
              return null;
            });
          },
          oneOf: function oneOf(e) {
            return Array.isArray(e) ? _(function (n, t, o, r, i) {
              for (var a = n[t], l = 0; l < e.length; l++) if (p(a, e[l])) return null;
              var d = JSON.stringify(e, function (e, n) {
                return "symbol" === y(n) ? String(n) : n;
              });
              return new m("Invalid " + r + " `" + i + "` of value `" + String(a) + "` supplied to `" + o + "`, expected one of " + d + ".");
            }) : ("production" !== process.env.NODE_ENV && i(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), a);
          },
          oneOfType: function oneOfType(e) {
            if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
            for (var n = 0; n < e.length; n++) {
              var r = e[n];
              if ("function" != typeof r) return i("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + w(r) + " at index " + n + "."), a;
            }
            return _(function (n, r, i, a, l) {
              for (var d = [], s = 0; s < e.length; s++) {
                var c = (0, e[s])(n, r, i, a, l, t);
                if (null == c) return null;
                c.data && o(c.data, "expectedType") && d.push(c.data.expectedType);
              }
              return new m("Invalid " + a + " `" + l + "` supplied to `" + i + "`" + (d.length > 0 ? ", expected one of type [" + d.join(", ") + "]" : "") + ".");
            });
          },
          shape: function shape(e) {
            return _(function (n, o, r, i, a) {
              var l = n[o],
                d = v(l);
              if ("object" !== d) return new m("Invalid " + i + " `" + a + "` of type `" + d + "` supplied to `" + r + "`, expected `object`.");
              for (var s in e) {
                var c = e[s];
                if ("function" != typeof c) return h(r, i, a, s, y(c));
                var u = c(l, s, r, i, a + "." + s, t);
                if (u) return u;
              }
              return null;
            });
          },
          exact: function exact(e) {
            return _(function (r, i, a, l, d) {
              var s = r[i],
                c = v(s);
              if ("object" !== c) return new m("Invalid " + l + " `" + d + "` of type `" + c + "` supplied to `" + a + "`, expected `object`.");
              var u = n({}, r[i], e);
              for (var p in u) {
                var _ = e[p];
                if (o(e, p) && "function" != typeof _) return h(a, l, d, p, y(_));
                if (!_) return new m("Invalid " + l + " `" + d + "` key `" + p + "` supplied to `" + a + "`.\nBad object: " + JSON.stringify(r[i], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                var f = _(s, p, a, l, d + "." + p, t);
                if (f) return f;
              }
              return null;
            });
          }
        };
      function p(e, n) {
        return e === n ? 0 !== e || 1 / e == 1 / n : e != e && n != n;
      }
      function m(e, n) {
        this.message = e, this.data = n && "object" == typeof n ? n : {}, this.stack = "";
      }
      function _(e) {
        if ("production" !== process.env.NODE_ENV) var n = {},
          o = 0;
        function r(r, a, l, s, u, p, _) {
          if (s = s || c, p = p || l, _ !== t) {
            if (d) {
              var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw f.name = "Invariant Violation", f;
            }
            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var h = s + ":" + l;
              !n[h] && o < 3 && (i("You are manually calling a React.PropTypes validation function for the `" + p + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[h] = !0, o++);
            }
          }
          return null == a[l] ? r ? null === a[l] ? new m("The " + u + " `" + p + "` is marked as required in `" + s + "`, but its value is `null`.") : new m("The " + u + " `" + p + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : e(a, l, s, u, p);
        }
        var a = r.bind(null, !1);
        return a.isRequired = r.bind(null, !0), a;
      }
      function f(e) {
        return _(function (n, t, o, r, i, a) {
          var l = n[t];
          return v(l) !== e ? new m("Invalid " + r + " `" + i + "` of type `" + y(l) + "` supplied to `" + o + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }
      function h(e, n, t, o, r) {
        return new m((e || "React class") + ": " + n + " type `" + t + "." + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + r + "`.");
      }
      function g(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e;
          case "object":
            if (Array.isArray(e)) return e.every(g);
            if (null === e || l(e)) return !0;
            var n = function (e) {
              var n = e && (s && e[s] || e["@@iterator"]);
              if ("function" == typeof n) return n;
            }(e);
            if (!n) return !1;
            var t,
              o = n.call(e);
            if (n !== e.entries) {
              for (; !(t = o.next()).done;) if (!g(t.value)) return !1;
            } else for (; !(t = o.next()).done;) {
              var r = t.value;
              if (r && !g(r[1])) return !1;
            }
            return !0;
          default:
            return !1;
        }
      }
      function v(e) {
        var n = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, n) {
          return "symbol" === e || !!n && ("Symbol" === n["@@toStringTag"] || "function" == typeof Symbol && n instanceof Symbol);
        }(n, e) ? "symbol" : n;
      }
      function y(e) {
        if (null == e) return "" + e;
        var n = v(e);
        if ("object" === n) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }
        return n;
      }
      function w(e) {
        var n = y(e);
        switch (n) {
          case "array":
          case "object":
            return "an " + n;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + n;
          default:
            return n;
        }
      }
      return m.prototype = Error.prototype, u.checkPropTypes = r, u.resetWarningCache = r.resetWarningCache, u.PropTypes = u, u;
    }, _n;
  }()(Cn.isElement, !0);
} else en.exports = function () {
  if (gn) return hn;
  gn = 1;
  var e = bn();
  function n() {}
  function t() {}
  return t.resetWarningCache = n, hn = function hn() {
    function o(n, t, o, r, i, a) {
      if (a !== e) {
        var l = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw l.name = "Invariant Violation", l;
      }
    }
    function r() {
      return o;
    }
    o.isRequired = o;
    var i = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: r,
      element: o,
      elementType: o,
      instanceOf: r,
      node: o,
      objectOf: r,
      oneOf: r,
      oneOfType: r,
      shape: r,
      exact: r,
      checkPropTypes: t,
      resetWarningCache: n
    };
    return i.PropTypes = i, i;
  };
}()();
var kn = en.exports,
  Mn = f(kn);
function Vn(e, n) {
  void 0 === n && (n = {});
  var t = n.insertAt;
  if (e && "undefined" != typeof document) {
    var o = document.head || document.getElementsByTagName("head")[0],
      r = document.createElement("style");
    r.type = "text/css", "top" === t && o.firstChild ? o.insertBefore(r, o.firstChild) : o.appendChild(r), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(document.createTextNode(e));
  }
}
var Ln = {
  modal_container: "VideoModal-module_modal_container__Epd5C",
  fadeIn: "VideoModal-module_fadeIn__9B7zt",
  fade_out: "VideoModal-module_fade_out__WekAr",
  fadeOut: "VideoModal-module_fadeOut__Zhyhp",
  backdrop_container: "VideoModal-module_backdrop_container__wXsJG",
  modal_body_container: "VideoModal-module_modal_body_container__jf3Fn",
  backdrop_logo: "VideoModal-module_backdrop_logo__xDB-9",
  top_row_container: "VideoModal-module_top_row_container__x4-3f",
  top_row_logo: "VideoModal-module_top_row_logo__ylDhA",
  top_row_buttons: "VideoModal-module_top_row_buttons__meVDI",
  top_row_button: "VideoModal-module_top_row_button__KlFFO",
  share_button: "VideoModal-module_share_button__qzffc",
  close_button: "VideoModal-module_close_button__gRR1E",
  social_button: "VideoModal-module_social_button__eYFI5",
  email: "VideoModal-module_email__9nGTu",
  reddit: "VideoModal-module_reddit__yFMyd",
  x: "VideoModal-module_x__88VQ2",
  facebook: "VideoModal-module_facebook__jLCQy",
  video_container: "VideoModal-module_video_container__MC9b2",
  show_controls: "VideoModal-module_show_controls__jmlVE",
  video_player: "VideoModal-module_video_player__DO5x-",
  video_title: "VideoModal-module_video_title__WEpw6",
  video_subtitle: "VideoModal-module_video_subtitle__plSSI",
  video_info_container: "VideoModal-module_video_info_container__fpIoN",
  team_info_sponsor_container: "VideoModal-module_team_info_sponsor_container__els-L",
  teams_container: "VideoModal-module_teams_container__29e4r",
  sponsor_container: "VideoModal-module_sponsor_container__gtVSA",
  nextup_video_container: "VideoModal-module_nextup_video_container__rPaKD",
  nextup_text: "VideoModal-module_nextup_text__5Y-Yl",
  nextup_video_title: "VideoModal-module_nextup_video_title__dg7DS",
  nextup_video_thumbnail: "VideoModal-module_nextup_video_thumbnail__bgxgw",
  team_info_container: "VideoModal-module_team_info_container__Z1HYr",
  team_logo: "VideoModal-module_team_logo__clko9",
  team_name: "VideoModal-module_team_name__BBy7o",
  button_wrapper: "VideoModal-module_button_wrapper__pNE4p",
  scrollable_container: "VideoModal-module_scrollable_container__bi-P1",
  tags_container: "VideoModal-module_tags_container__ye1b8",
  pinned: "VideoModal-module_pinned__Jurv3",
  tag: "VideoModal-module_tag__fuAMC",
  selected: "VideoModal-module_selected__FedL6",
  recommended_videos_container: "VideoModal-module_recommended_videos_container__uhybo",
  recommended_video_wrapper: "VideoModal-module_recommended_video_wrapper__GC-oJ",
  recommended_video_spacer: "VideoModal-module_recommended_video_spacer__dHjsf",
  ad_wrapper: "VideoModal-module_ad_wrapper__bC-4B",
  recommended_video_thumbnail: "VideoModal-module_recommended_video_thumbnail__NAngp",
  playing_indicator: "VideoModal-module_playing_indicator__vq9U0",
  playing: "VideoModal-module_playing__8TsiY",
  recommended_video_title: "VideoModal-module_recommended_video_title__CzdDl",
  recommended_video_subtitle: "VideoModal-module_recommended_video_subtitle__-29zA",
  recommended_video_duration: "VideoModal-module_recommended_video_duration__vDsKt",
  video_loading_wrapper: "VideoModal-module_video_loading_wrapper__Y8caz",
  recommended_videos_wrapper: "VideoModal-module_recommended_videos_wrapper__HYvzK",
  scroll_back_button_wrapper: "VideoModal-module_scroll_back_button_wrapper__SG4Iz",
  disabled: "VideoModal-module_disabled__1w5qK",
  scroll_forward_button_wrapper: "VideoModal-module_scroll_forward_button_wrapper__8rUDP",
  button: "VideoModal-module_button__Sf7P1"
};
function En() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) n[t] = arguments[t];
  return n.filter(Boolean).join(" ");
}
function jn() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
  if (!e) return " ";
  var n = new Date(e),
    t = n.toLocaleDateString("en-US", {
      weekday: "long"
    }),
    o = n.toLocaleDateString("en-US", {
      month: "long"
    }),
    r = n.getDate(),
    i = n.getFullYear(),
    a = n.getHours(),
    l = n.getMinutes(),
    d = "AM";
  return a > 12 && (a -= 12, d = "PM"), l < 10 && (l = "0".concat(l)), "".concat(a, ":").concat(l, " ").concat(d, ", ").concat(t, " ").concat(o, " ").concat(r, ", ").concat(i);
}
function On() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
  if (!e) return " ";
  var n = e / 1e3,
    t = Math.floor(n / 60),
    o = Math.floor(n % 60);
  return "".concat(t, ":").concat(o < 10 ? "0" : "").concat(o);
}
function Nn(e) {
  var n,
    t = this,
    o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100;
  return function () {
    for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) i[a] = arguments[a];
    clearTimeout(n), n = setTimeout(function () {
      e.apply(t, i);
    }, o);
  };
}
Vn('.VideoModal-module_modal_container__Epd5C {\n  overflow: hidden;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 10000;\n  animation: VideoModal-module_fadeIn__9B7zt 300ms ease-in-out;\n}\n.VideoModal-module_modal_container__Epd5C.VideoModal-module_fade_out__WekAr {\n  animation: VideoModal-module_fadeOut__Zhyhp 300ms ease-in-out;\n}\n\n.VideoModal-module_backdrop_container__wXsJG {\n  background: radial-gradient(60.65% 60.65% at 50% 0%, rgba(0, 94, 184, 0.98) 33.33%, rgba(11, 34, 62, 0.98) 100%);\n  width: 100%;\n  height: 100%;\n}\n\n.VideoModal-module_modal_body_container__jf3Fn {\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  height: 100%;\n  overflow-y: scroll;\n}\n\n.VideoModal-module_backdrop_logo__xDB-9 {\n  position: absolute;\n  left: -40%;\n  top: -10%;\n  width: 190%;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_backdrop_logo__xDB-9 {\n    left: -10%;\n    top: -40px;\n    width: 120%;\n  }\n}\n.VideoModal-module_backdrop_logo__xDB-9 img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.VideoModal-module_top_row_container__x4-3f {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 26px 16px 10px 16px;\n  margin-top: 24px;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_top_row_container__x4-3f {\n    margin-top: 0px;\n  }\n}\n@media (min-width: 992px) {\n  .VideoModal-module_top_row_container__x4-3f {\n    width: 100%;\n    max-width: 980px;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 26px 0 10px 0;\n  }\n}\n@media only screen and (max-height: 575.98px) and (orientation: landscape) {\n  .VideoModal-module_top_row_container__x4-3f {\n    position: absolute;\n    right: 0;\n    padding-top: 0;\n  }\n}\n\n.VideoModal-module_top_row_logo__ylDhA {\n  height: 30px;\n}\n@media only screen and (max-height: 575.98px) and (orientation: landscape) {\n  .VideoModal-module_top_row_logo__ylDhA {\n    display: none;\n  }\n}\n\n.VideoModal-module_top_row_buttons__meVDI {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n@media only screen and (max-height: 575.98px) and (orientation: landscape) {\n  .VideoModal-module_top_row_buttons__meVDI {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n}\n\n.VideoModal-module_top_row_button__KlFFO {\n  display: inline-block;\n  align-items: center;\n  position: relative;\n  width: 40px;\n  height: 40px;\n  background-color: #06192f !important;\n  border-radius: 50%;\n  cursor: pointer;\n  margin-left: 16px;\n  padding: 8px;\n}\n.VideoModal-module_top_row_button__KlFFO:hover {\n  background-color: #005eb8 !important;\n}\n@media only screen and (max-height: 575.98px) and (orientation: landscape) {\n  .VideoModal-module_top_row_button__KlFFO {\n    margin-top: 16px;\n  }\n}\n\n.VideoModal-module_share_button__qzffc {\n  width: 40px;\n  height: 40px;\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.9"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.5593 3.46978L12.0289 2.93945L11.4986 3.46978L8.09858 6.86983C7.80568 7.16272 7.80568 7.63759 8.09858 7.93049C8.39147 8.22338 8.86634 8.22338 9.15924 7.93049L11.2783 5.8114L11.2783 13.0668C11.2783 13.4811 11.6141 13.8168 12.0283 13.8168C12.4425 13.8168 12.7783 13.4811 12.7783 13.0668V5.81015L14.8987 7.93049C15.1916 8.22338 15.6664 8.22338 15.9593 7.93049C16.2522 7.63759 16.2522 7.16272 15.9593 6.86983L12.5593 3.46978ZM5.22852 14.3573C5.64273 14.3573 5.97852 14.6931 5.97852 15.1073V17.3573C5.97852 18.0477 6.53816 18.6073 7.22852 18.6073H16.8287C17.519 18.6073 18.0787 18.0477 18.0787 17.3573V15.1073C18.0787 14.6931 18.4145 14.3573 18.8287 14.3573C19.2429 14.3573 19.5787 14.6931 19.5787 15.1073V17.3573C19.5787 18.8761 18.3475 20.1073 16.8287 20.1073H7.22852C5.70974 20.1073 4.47852 18.8761 4.47852 17.3573V15.1073C4.47852 14.6931 4.8143 14.3573 5.22852 14.3573Z" fill="white"/></g></svg>\');\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.VideoModal-module_close_button__gRR1E {\n  width: 40px;\n  height: 40px;\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.9"><path d="M18.75 5.25L5.25 18.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.75 18.75L5.25 5.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g></svg>\');\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.VideoModal-module_social_button__eYFI5 {\n  cursor: pointer;\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  margin-right: 16px;\n}\n.VideoModal-module_social_button__eYFI5.VideoModal-module_email__9nGTu {\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6L19 6V16.625C19 16.7908 18.9342 16.9497 18.8169 17.0669C18.6997 17.1842 18.5408 17.25 18.375 17.25H4.625C4.45924 17.25 4.30027 17.1842 4.18306 17.0669C4.06585 16.9497 4 16.7908 4 16.625L4 6Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 6L11.5 12.875L4 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n.VideoModal-module_social_button__eYFI5.VideoModal-module_reddit__yFMyd {\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.625 4.5C18.4534 4.5 19.125 3.82843 19.125 3C19.125 2.17157 18.4534 1.5 17.625 1.5C16.7966 1.5 16.125 2.17157 16.125 3C16.125 3.82843 16.7966 4.5 17.625 4.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.0938 16.5C14.1373 16.9941 13.0765 17.2519 12 17.2519C10.9235 17.2519 9.86266 16.9941 8.90625 16.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 6.75L12.75 2.25L16.1437 2.775" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.56879 8.42813C7.28441 7.37813 9.53441 6.75 12 6.75C14.4657 6.75 16.7157 7.37813 18.4313 8.42813C18.6281 8.1581 18.8825 7.93529 19.1761 7.77586C19.4697 7.61644 19.7952 7.52441 20.1288 7.50646C20.4624 7.48851 20.7959 7.54508 21.1049 7.67208C21.414 7.79907 21.6908 7.9933 21.9154 8.24065C22.14 8.488 22.3067 8.78227 22.4034 9.10209C22.5001 9.4219 22.5244 9.75924 22.4744 10.0896C22.4245 10.42 22.3016 10.735 22.1147 11.012C21.9277 11.2889 21.6815 11.5207 21.3938 11.6906V11.6906C21.6295 12.2647 21.7505 12.8794 21.75 13.5C21.75 17.2312 17.3813 20.25 12 20.25C6.61879 20.25 2.25004 17.2312 2.25004 13.5C2.24953 12.8794 2.37055 12.2647 2.60629 11.6906V11.6906C2.31859 11.5207 2.07234 11.2889 1.88542 11.012C1.6985 10.735 1.57561 10.42 1.52565 10.0896C1.4757 9.75924 1.49995 9.4219 1.59664 9.10209C1.69333 8.78227 1.86003 8.488 2.08464 8.24065C2.30924 7.9933 2.58612 7.79907 2.89515 7.67208C3.20419 7.54508 3.53763 7.48851 3.87126 7.50646C4.20489 7.52441 4.53033 7.61644 4.82396 7.77586C5.11758 7.93529 5.37202 8.1581 5.56879 8.42813V8.42813Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.25 13.5C8.87132 13.5 9.375 12.9963 9.375 12.375C9.375 11.7537 8.87132 11.25 8.25 11.25C7.62868 11.25 7.125 11.7537 7.125 12.375C7.125 12.9963 7.62868 13.5 8.25 13.5Z" fill="white"/><path d="M15.75 13.5C16.3713 13.5 16.875 12.9963 16.875 12.375C16.875 11.7537 16.3713 11.25 15.75 11.25C15.1287 11.25 14.625 11.7537 14.625 12.375C14.625 12.9963 15.1287 13.5 15.75 13.5Z" fill="white"/></svg>\');\n}\n.VideoModal-module_social_button__eYFI5.VideoModal-module_x__88VQ2 {\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.7627 2.51886C19.0304 2.20282 19.5037 2.16369 19.8197 2.43145C20.1357 2.69921 20.1749 3.17246 19.9071 3.4885L14.2504 10.1651L20.7842 19.7947C21.3473 20.6246 20.7528 21.7465 19.7498 21.7465H15.7809C15.3666 21.7465 14.9792 21.5412 14.7465 21.1983L10.3689 14.7464L4.66276 21.4813C4.395 21.7973 3.92174 21.8365 3.6057 21.5687C3.28967 21.301 3.25053 20.8277 3.51829 20.5117L9.49459 13.4579L3.21678 4.20551C2.65363 3.37553 3.24817 2.25368 4.25115 2.25368H8.22002C8.63436 2.25368 9.02176 2.45899 9.2544 2.80185L13.3761 8.87654L18.7627 2.51886ZM15.9134 20.2465L4.72289 3.75368H8.08753L19.278 20.2465H15.9134Z" fill="white"/></svg>\');\n}\n.VideoModal-module_social_button__eYFI5.VideoModal-module_facebook__jLCQy {\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.75 8.25002H14.25C13.9542 8.24878 13.6611 8.30613 13.3875 8.41876C13.114 8.5314 12.8654 8.69708 12.6563 8.90626C12.4471 9.11544 12.2814 9.36397 12.1688 9.63752C12.0561 9.91106 11.9988 10.2042 12 10.5L12 21" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 13.5L15 13.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n.VideoModal-module_social_button__eYFI5:hover.VideoModal-module_email__9nGTu {\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6L19 6V16.625C19 16.7908 18.9342 16.9497 18.8169 17.0669C18.6997 17.1842 18.5408 17.25 18.375 17.25H4.625C4.45924 17.25 4.30027 17.1842 4.18306 17.0669C4.06585 16.9497 4 16.7908 4 16.625L4 6Z" stroke="%230ab6ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 6L11.5 12.875L4 6" stroke="%230ab6ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n.VideoModal-module_social_button__eYFI5:hover.VideoModal-module_reddit__yFMyd {\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.625 4.5C18.4534 4.5 19.125 3.82843 19.125 3C19.125 2.17157 18.4534 1.5 17.625 1.5C16.7966 1.5 16.125 2.17157 16.125 3C16.125 3.82843 16.7966 4.5 17.625 4.5Z" stroke="%230ab6ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.0938 16.5C14.1373 16.9941 13.0765 17.2519 12 17.2519C10.9235 17.2519 9.86266 16.9941 8.90625 16.5" stroke="%230ab6ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 6.75L12.75 2.25L16.1437 2.775" stroke="%230ab6ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.56879 8.42813C7.28441 7.37813 9.53441 6.75 12 6.75C14.4657 6.75 16.7157 7.37813 18.4313 8.42813C18.6281 8.1581 18.8825 7.93529 19.1761 7.77586C19.4697 7.61644 19.7952 7.52441 20.1288 7.50646C20.4624 7.48851 20.7959 7.54508 21.1049 7.67208C21.414 7.79907 21.6908 7.9933 21.9154 8.24065C22.14 8.488 22.3067 8.78227 22.4034 9.10209C22.5001 9.4219 22.5244 9.75924 22.4744 10.0896C22.4245 10.42 22.3016 10.735 22.1147 11.012C21.9277 11.2889 21.6815 11.5207 21.3938 11.6906V11.6906C21.6295 12.2647 21.7505 12.8794 21.75 13.5C21.75 17.2312 17.3813 20.25 12 20.25C6.61879 20.25 2.25004 17.2312 2.25004 13.5C2.24953 12.8794 2.37055 12.2647 2.60629 11.6906V11.6906C2.31859 11.5207 2.07234 11.2889 1.88542 11.012C1.6985 10.735 1.57561 10.42 1.52565 10.0896C1.4757 9.75924 1.49995 9.4219 1.59664 9.10209C1.69333 8.78227 1.86003 8.488 2.08464 8.24065C2.30924 7.9933 2.58612 7.79907 2.89515 7.67208C3.20419 7.54508 3.53763 7.48851 3.87126 7.50646C4.20489 7.52441 4.53033 7.61644 4.82396 7.77586C5.11758 7.93529 5.37202 8.1581 5.56879 8.42813V8.42813Z" stroke="%230ab6ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.25 13.5C8.87132 13.5 9.375 12.9963 9.375 12.375C9.375 11.7537 8.87132 11.25 8.25 11.25C7.62868 11.25 7.125 11.7537 7.125 12.375C7.125 12.9963 7.62868 13.5 8.25 13.5Z" fill="%230ab6ff"/><path d="M15.75 13.5C16.3713 13.5 16.875 12.9963 16.875 12.375C16.875 11.7537 16.3713 11.25 15.75 11.25C15.1287 11.25 14.625 11.7537 14.625 12.375C14.625 12.9963 15.1287 13.5 15.75 13.5Z" fill="%230ab6ff"/></svg>\');\n}\n.VideoModal-module_social_button__eYFI5:hover.VideoModal-module_x__88VQ2 {\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.7627 2.51886C19.0304 2.20282 19.5037 2.16369 19.8197 2.43145C20.1357 2.69921 20.1749 3.17246 19.9071 3.4885L14.2504 10.1651L20.7842 19.7947C21.3473 20.6246 20.7528 21.7465 19.7498 21.7465H15.7809C15.3666 21.7465 14.9792 21.5412 14.7465 21.1983L10.3689 14.7464L4.66276 21.4813C4.395 21.7973 3.92174 21.8365 3.6057 21.5687C3.28967 21.301 3.25053 20.8277 3.51829 20.5117L9.49459 13.4579L3.21678 4.20551C2.65363 3.37553 3.24817 2.25368 4.25115 2.25368H8.22002C8.63436 2.25368 9.02176 2.45899 9.2544 2.80185L13.3761 8.87654L18.7627 2.51886ZM15.9134 20.2465L4.72289 3.75368H8.08753L19.278 20.2465H15.9134Z" fill="%230ab6ff"/></svg>\');\n}\n.VideoModal-module_social_button__eYFI5:hover.VideoModal-module_facebook__jLCQy {\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="%230ab6ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.75 8.25002H14.25C13.9542 8.24878 13.6611 8.30613 13.3875 8.41876C13.114 8.5314 12.8654 8.69708 12.6563 8.90626C12.4471 9.11544 12.2814 9.36397 12.1688 9.63752C12.0561 9.91106 11.9988 10.2042 12 10.5L12 21" stroke="%230ab6ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 13.5L15 13.5" stroke="%230ab6ff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n\n.VideoModal-module_video_container__MC9b2.VideoModal-module_show_controls__jmlVE .vjs-control-bar {\n  opacity: 1 !important;\n  pointer-events: inherit !important;\n  cursor: inherit !important;\n}\n.VideoModal-module_video_container__MC9b2.VideoModal-module_show_controls__jmlVE .vjs-ad-control-bar {\n  opacity: 1 !important;\n  pointer-events: inherit !important;\n  cursor: inherit !important;\n}\n.VideoModal-module_video_container__MC9b2.VideoModal-module_show_controls__jmlVE .vjs-title-bar {\n  opacity: 1 !important;\n}\n\n.VideoModal-module_video_player__DO5x- {\n  position: relative;\n  width: 100%;\n  max-width: 980px;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  aspect-ratio: 16/9;\n  height: auto;\n}\n.VideoModal-module_video_player__DO5x- .video-js {\n  width: 100%;\n  aspect-ratio: 16/9;\n  height: auto;\n}\n.VideoModal-module_video_player__DO5x- .vastIcon.videoAdUiIconV2 {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-control-bar {\n  transition: opacity 0.3s ease-in-out !important;\n  position: absolute;\n  top: 0;\n  height: 100%;\n  transform: none !important;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.4) 30%, rgba(0, 0, 0, 0.4) 70%, rgba(0, 0, 0, 0.8) 100%);\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-control-bar {\n    background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 20%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.7) 80%, rgb(0, 0, 0) 100%);\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar {\n  display: block !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar .vjs-button {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar .vjs-progress-control {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar .vjs-duration {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar .vjs-current-time {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar .vjs-play-control {\n  display: block !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar .vjs-remaining-time {\n  position: absolute;\n  height: auto;\n  top: 0;\n  left: 0;\n  display: block !important;\n  opacity: 1 !important;\n  font-size: 14px;\n  color: white;\n  font-family: "roboto", sans-serif;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-ad-control-bar .vjs-remaining-time {\n    font-size: 18px;\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar .vjs-remaining-time::before {\n  content: "Ad - ";\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar .vjs-remaining-time span {\n  display: none;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar .vjs-remaining-time .vjs-remaining-time-display {\n  display: inline !important;\n  opacity: 1 !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-control-bar {\n  opacity: 0 !important;\n  pointer-events: none !important;\n  cursor: default !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-control-bar {\n  opacity: 0 !important;\n  pointer-events: none !important;\n  cursor: default !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-title-bar {\n  opacity: 0 !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-loading .vjs-skip-backward-button {\n  display: none;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-loading .vjs-skip-forward-button {\n  display: none;\n}\n.VideoModal-module_video_player__DO5x- .vjs-loading-spinner {\n  background-color: #141917;\n  width: 80px;\n  height: 80px;\n  margin: -40px 0 0 -40px;\n  background-image: url(\'data:image/svg+xml,<%3Fxml version="1.0" encoding="utf-8"%3F>\x3c!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --\x3e<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 230.1 133" style="enable-background:new 0 0 230.1 133;" xml:space="preserve"><style type="text/css">.st0{fill:%23FFFFFF;}.st1{fill:%23FFFFFF;}.st2{fill:%23FFFFFF;}</style><g><path class="st0" d="M134.6,132c18.6-18.9,63.5-1.8,68.1-2.3c2.4-0.2,3.4-3.6-1.2-5.5C156.9,106.5,91.2,102,55.1,108.5c-4,1.1-5.3,4.6,0.9,5.3c6.3,0.8,22.4,2,45.3,7.4c12.7,3,22.1,7.1,30.2,11.5C132.6,133.2,133.5,133.1,134.6,132"/><path class="st1" d="M206.5,115.1l3.8-18C140.3,76,73.4,77.1,2.8,102.2c-3.6,1.2-4.7,6.4,2.7,5.3c10.9-1.7,54.7-7.6,93.8-7.8c31.4-0.2,69.4,6.5,101.2,17C204.1,117.7,205.9,117.2,206.5,115.1z"/><g><path class="st2" d="M201,2.1l-11.4,53.4h-0.3L173.8,2.1h-57.4l-5.1,23.7h8.3l-10.4,48.8c1.6,0,3.2-0.1,4.7-0.1c8.1,0,16.1,0.3,24.2,0.9L149,25h0.2l15.5,53.6c15.3,2.5,30.8,6.1,46.6,10.9c0.1,0,0.2,0.1,0.2,0.1l18.5-87.5H201z"/><path class="st2" d="M107.2,25.8C110.3,9.4,102,0,68.1,0C36.3,0,18.6,7.8,14.9,25.3c-1,4.5-0.8,10.1,2.7,13.9c8.7,9.4,46,13.1,49.4,18.2c0.7,1,1,2.2,0.7,3.6c-1.4,6.4-9.2,8.1-16.2,8.1c-4.4,0-7.2-1.1-8.9-3.2c-1.6-2.1-1.9-5.3-1-9.7H7.3C5,69.9,4.3,82,39,83.6c17.1-4.1,34.1-6.8,51-8.2c7.5-4.4,11.6-10.4,13.1-17.6c1.6-7.7-0.6-12-3.1-14.8c-8.6-9.5-44.7-13-48.8-18c-0.8-0.9-0.9-2.4-0.7-3.6c0.9-4.1,5.2-6.7,12.2-6.7c4.2,0,7.4,0.6,9.4,2.2c2.1,1.7,2.9,4.4,2.2,8.8H107.2z"/></g></g></svg>\');\n  background-repeat: no-repeat;\n  background-position: 50% 52%;\n  background-size: 40px;\n  border: 3px solid #141917;\n  border-radius: 40px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-loading-spinner::before {\n  border-top-color: white !important;\n  margin: -3px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-loading-spinner::after {\n  border-top-color: white !important;\n  margin: -3px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-hide-controls .vjs-big-play-button {\n  background-color: #005eb8 !important;\n  color: white !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-big-play-button {\n  color: #005eb8 !important;\n  background-color: white !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-ad-playing .vjs-title-bar {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-skip-backward-button {\n  display: block;\n  background-image: url(\'data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 16.25L6.25 10L12.5 3.75" stroke="%23005EB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  position: absolute;\n  left: 22px;\n  top: calc(50% - 20px);\n  bottom: 96px;\n  width: 40px;\n  height: 40px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-skip-backward-button:hover {\n  background-color: #005eb8;\n  background-image: url(\'data:image/svg+xml,<svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.83333 13.3327L0.999999 7.49935L6.83333 1.66602" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n@media (min-width: 992px) {\n  .VideoModal-module_video_player__DO5x- .vjs-skip-backward-button {\n    top: calc(50% - 30px);\n    bottom: 96px;\n    width: 60px;\n    height: 60px;\n    left: 24px;\n    background-image: url(\'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 26L10 16L20 6" stroke="%23005EB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  }\n  .VideoModal-module_video_player__DO5x- .vjs-skip-backward-button:hover {\n    background-image: url(\'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 26L10 16L20 6" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-skip-forward-button {\n  display: block;\n  background-image: url(\'data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 3.75L13.75 10L7.5 16.25" stroke="%23005EB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  position: absolute;\n  right: 22px;\n  top: calc(50% - 20px);\n  bottom: 96px;\n  width: 40px;\n  height: 40px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-skip-forward-button:hover {\n  background-color: #005eb8;\n  background-image: url(\'data:image/svg+xml,<svg width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n@media (min-width: 992px) {\n  .VideoModal-module_video_player__DO5x- .vjs-skip-forward-button {\n    top: calc(50% - 30px);\n    bottom: 96px;\n    width: 60px;\n    height: 60px;\n    right: 24px;\n    background-image: url(\'data:image/svg+xml,<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6L22 16L12 26" stroke="%23005EB8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  }\n  .VideoModal-module_video_player__DO5x- .vjs-skip-forward-button:hover {\n    background-image: url(\'data:image/svg+xml,<svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L11 11L1 21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  }\n}\n.VideoModal-module_video_player__DO5x- .irisIcon:before {\n  display: none;\n}\n.VideoModal-module_video_player__DO5x- .vjs-play-control {\n  position: absolute;\n  left: calc(50% - 16px);\n  top: calc(50% - 16px);\n  width: 32px;\n  height: 32px;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-play-control {\n    bottom: 24px;\n    top: auto;\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-play-control.vjs-paused {\n  background-image: url(\'data:image/svg+xml,<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29.0125 15.15L11.025 4.15C10.8736 4.05659 10.7 4.00528 10.5221 4.00134C10.3442 3.99741 10.1685 4.041 10.0131 4.12762C9.85774 4.21424 9.72826 4.34075 9.63805 4.4941C9.54785 4.64745 9.5002 4.82208 9.5 5V27C9.5002 27.1779 9.54785 27.3525 9.63805 27.5059C9.72826 27.6592 9.85774 27.7858 10.0131 27.8724C10.1685 27.959 10.3442 28.0026 10.5221 27.9986C10.7 27.9947 10.8736 27.9434 11.025 27.85L29.0125 16.85C29.1602 16.7627 29.2826 16.6383 29.3676 16.4893C29.4526 16.3402 29.4974 16.1716 29.4974 16C29.4974 15.8284 29.4526 15.6598 29.3676 15.5107C29.2826 15.3617 29.1602 15.2373 29.0125 15.15V15.15Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n.VideoModal-module_video_player__DO5x- .vjs-play-control.vjs-playing {\n  background-image: url(\'data:image/svg+xml,<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.5 5H21C20.4477 5 20 5.44772 20 6V26C20 26.5523 20.4477 27 21 27H25.5C26.0523 27 26.5 26.5523 26.5 26V6C26.5 5.44772 26.0523 5 25.5 5Z" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 5H7.5C6.94772 5 6.5 5.44772 6.5 6V26C6.5 26.5523 6.94772 27 7.5 27H12C12.5523 27 13 26.5523 13 26V6C13 5.44772 12.5523 5 12 5Z" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n.VideoModal-module_video_player__DO5x- .vjs-play-control .vjs-icon-placeholder {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-skip-forward-10 {\n  position: absolute;\n  left: calc(50% + 42px);\n  top: calc(50% - 16px);\n  width: 32px;\n  height: 32px;\n  background-image: url(\'data:image/svg+xml,<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.4969 5.94757C16.5084 5.55139 14.447 5.75389 12.5736 6.52944C10.7001 7.30499 9.09881 8.61876 7.97216 10.3045C6.8455 11.9903 6.24414 13.9724 6.24414 16C6.24414 18.0276 6.8455 20.0097 7.97216 21.6955C9.09881 23.3813 10.7001 24.695 12.5736 25.4706C14.447 26.2461 16.5084 26.4486 18.4969 26.0524C20.4854 25.6563 22.3118 24.6792 23.7449 23.2449C24.0377 22.9519 24.5126 22.9517 24.8056 23.2445C25.0986 23.5372 25.0988 24.0121 24.806 24.3051C23.1631 25.9493 21.0695 27.0694 18.79 27.5235C16.5104 27.9777 14.1474 27.7456 11.9998 26.8565C9.85223 25.9675 8.01657 24.4614 6.72504 22.529C5.43351 20.5965 4.74414 18.3243 4.74414 16C4.74414 13.6757 5.43351 11.4035 6.72504 9.47106C8.01657 7.53857 9.85223 6.03255 11.9998 5.1435C14.1474 4.25446 16.5104 4.02233 18.79 4.47648C21.0692 4.93058 23.1626 6.05039 24.8054 7.69429L24.806 7.69489L27.7754 10.6555V7.46252C27.7754 7.04831 28.1112 6.71252 28.5254 6.71252C28.9396 6.71252 29.2754 7.04831 29.2754 7.46252V12.4504C29.2785 12.646 29.2056 12.8426 29.0566 12.9921C28.9793 13.0695 28.8893 13.1266 28.7933 13.1632C28.7101 13.1951 28.6198 13.2125 28.5254 13.2125H23.5254C23.1112 13.2125 22.7754 12.8767 22.7754 12.4625C22.7754 12.0483 23.1112 11.7125 23.5254 11.7125H26.7111L23.7459 8.75612L23.7449 8.75512C22.3118 7.32079 20.4854 6.34374 18.4969 5.94757ZM20.8798 17.644V14.86C20.8798 13.324 20.1838 11.848 17.9038 11.848C15.5038 11.848 14.7838 13.42 14.7838 14.992V17.704C14.7838 19.3 15.4438 20.716 17.7598 20.716C20.2078 20.716 20.8798 19.18 20.8798 17.644ZM16.6558 17.824V14.74C16.6558 13.78 17.0398 13.276 17.8558 13.276C18.6718 13.276 18.9958 13.792 18.9958 14.704V17.836C18.9958 18.736 18.6598 19.264 17.8078 19.264C17.0278 19.264 16.6558 18.82 16.6558 17.824ZM9.77148 13.036V14.464L11.3315 13.912V20.5H13.1675V12.064H11.9915L9.77148 13.036Z" fill="white"/></svg>\');\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-skip-forward-10 {\n    bottom: 24px;\n    top: auto;\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-skip-forward-10 .vjs-icon-placeholder {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-skip-backward-10 {\n  position: absolute;\n  left: calc(50% - 74px);\n  top: calc(50% - 16px);\n  width: 32px;\n  height: 32px;\n  background-image: url(\'data:image/svg+xml,<svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.2101 4.47648C16.4897 4.02233 18.8527 4.25446 21.0003 5.1435C23.1479 6.03255 24.9835 7.53857 26.2751 9.47106C27.5666 11.4035 28.256 13.6757 28.256 16C28.256 18.3243 27.5666 20.5965 26.2751 22.529C24.9835 24.4614 23.1479 25.9675 21.0003 26.8565C18.8527 27.7456 16.4897 27.9777 14.2101 27.5235C11.9306 27.0694 9.83695 25.9493 8.19406 24.3051C7.90129 24.0121 7.90148 23.5372 8.1945 23.2445C8.48751 22.9517 8.96238 22.9519 9.25516 23.2449C10.6883 24.6792 12.5147 25.6563 14.5032 26.0524C16.4917 26.4486 18.5531 26.2461 20.4265 25.4706C22.3 24.695 23.9013 23.3813 25.0279 21.6955C26.1546 20.0097 26.756 18.0276 26.756 16C26.756 13.9724 26.1546 11.9903 25.0279 10.3045C23.9013 8.61876 22.3 7.30499 20.4265 6.52944C18.5531 5.75389 16.4917 5.55139 14.5032 5.94757C12.5147 6.34375 10.6883 7.32079 9.25516 8.75512L9.25416 8.75612L6.28903 11.7125H9.47461C9.88882 11.7125 10.2246 12.0483 10.2246 12.4625C10.2246 12.8767 9.88882 13.2125 9.47461 13.2125H4.47461C4.36471 13.2125 4.26033 13.1889 4.16627 13.1464C4.09839 13.1158 4.03413 13.0746 3.97601 13.0228C3.95456 13.0037 3.93422 12.9834 3.91508 12.962C3.85951 12.8998 3.8161 12.8306 3.78485 12.7575C3.74608 12.667 3.72461 12.5673 3.72461 12.4625V12.4623V7.46252C3.72461 7.04831 4.0604 6.71252 4.47461 6.71252C4.88882 6.71252 5.22461 7.04831 5.22461 7.46252V10.6556L8.19406 7.69489L8.19453 7.69442C9.83735 6.05045 11.9308 4.93059 14.2101 4.47648ZM22.8798 17.644V14.86C22.8798 13.324 22.1838 11.848 19.9038 11.848C17.5038 11.848 16.7838 13.42 16.7838 14.992V17.704C16.7838 19.3 17.4438 20.716 19.7598 20.716C22.2078 20.716 22.8798 19.18 22.8798 17.644ZM18.6558 17.824V14.74C18.6558 13.78 19.0398 13.276 19.8558 13.276C20.6718 13.276 20.9958 13.792 20.9958 14.704V17.836C20.9958 18.736 20.6598 19.264 19.8078 19.264C19.0278 19.264 18.6558 18.82 18.6558 17.824ZM11.7715 13.036V14.464L13.3315 13.912V20.5H15.1675V12.064H13.9915L11.7715 13.036Z" fill="white"/></svg>\');\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-skip-backward-10 {\n    bottom: 24px;\n    top: auto;\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-skip-backward-10 .vjs-icon-placeholder {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-fullscreen-control {\n  width: 24px;\n  height: 24px;\n  margin-top: 12px;\n  margin-right: 5%;\n  background-image: url(\'data:image/svg+xml,<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.3501 4.5H20.1001V8.25" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.8501 19.5H5.1001V15.75" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.1001 15.75V19.5H16.3501" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.1001 8.25V4.5H8.8501" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-fullscreen-control {\n    position: absolute;\n    right: 24px;\n    bottom: 28px;\n    top: auto;\n    margin: 0;\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-fullscreen-control .vjs-icon-placeholder {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-fullscreen-control[title="Exit Fullscreen"] {\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.75 4.5C15.75 4.08579 15.4142 3.75 15 3.75C14.5858 3.75 14.25 4.08579 14.25 4.5V9C14.25 9.41421 14.5858 9.75 15 9.75H19.5C19.9142 9.75 20.25 9.41421 20.25 9C20.25 8.58579 19.9142 8.25 19.5 8.25H15.75V4.5ZM4.5 14.25C4.08579 14.25 3.75 14.5858 3.75 15C3.75 15.4142 4.08579 15.75 4.5 15.75H8.25V19.5C8.25 19.9142 8.58579 20.25 9 20.25C9.41421 20.25 9.75 19.9142 9.75 19.5V15C9.75 14.5858 9.41421 14.25 9 14.25H4.5ZM14.25 15C14.25 14.5858 14.5858 14.25 15 14.25H19.5C19.9142 14.25 20.25 14.5858 20.25 15C20.25 15.4142 19.9142 15.75 19.5 15.75H15.75V19.5C15.75 19.9142 15.4142 20.25 15 20.25C14.5858 20.25 14.25 19.9142 14.25 19.5V15ZM9.75 4.5C9.75 4.08579 9.41421 3.75 9 3.75C8.58579 3.75 8.25 4.08579 8.25 4.5V8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9C3.75 9.41421 4.08579 9.75 4.5 9.75H9C9.41421 9.75 9.75 9.41421 9.75 9V4.5Z" fill="white" fill-opacity="0.9"/></svg>\');\n}\n.VideoModal-module_video_player__DO5x- button.vjs-subs-caps-button {\n  width: 24px;\n  height: 24px;\n  margin-top: 12px;\n  margin-right: 5%;\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="ClosedCaptioning"><path id="Vector" d="M20.25 4.5H3.75C3.33579 4.5 3 4.83579 3 5.25V18.75C3 19.1642 3.33579 19.5 3.75 19.5H20.25C20.6642 19.5 21 19.1642 21 18.75V5.25C21 4.83579 20.6642 4.5 20.25 4.5Z" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_2" d="M10.8751 13.8375C10.5101 14.2099 10.0425 14.4651 9.5319 14.5706C9.02128 14.6762 8.4908 14.6273 8.00808 14.4302C7.52537 14.2331 7.1123 13.8966 6.82153 13.4638C6.53077 13.031 6.37549 12.5214 6.37549 12C6.37549 11.4786 6.53077 10.969 6.82153 10.5362C7.1123 10.1034 7.52537 9.76695 8.00808 9.56982C8.4908 9.3727 9.02128 9.3238 9.5319 9.42935C10.0425 9.53491 10.5101 9.79014 10.8751 10.1625" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path id="Vector_3" d="M17.6251 13.8375C17.2601 14.2099 16.7925 14.4651 16.2819 14.5706C15.7713 14.6762 15.2408 14.6273 14.7581 14.4302C14.2754 14.2331 13.8623 13.8966 13.5715 13.4638C13.2808 13.031 13.1255 12.5214 13.1255 12C13.1255 11.4786 13.2808 10.969 13.5715 10.5362C13.8623 10.1034 14.2754 9.76695 14.7581 9.56982C15.2408 9.3727 15.7713 9.3238 16.2819 9.42935C16.7925 9.53491 17.2601 9.79014 17.6251 10.1625" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g></svg>\');\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- button.vjs-subs-caps-button {\n    position: absolute;\n    right: 64px;\n    bottom: 28px;\n    top: auto;\n    margin: 0;\n  }\n}\n.VideoModal-module_video_player__DO5x- button.vjs-subs-caps-button .vjs-icon-placeholder {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-subs-caps-button .vjs-menu {\n  left: -80px;\n  bottom: 12px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-volume-panel {\n  width: 24px;\n  height: 24px;\n  margin-left: 5%;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-volume-panel {\n    position: absolute;\n    left: 24px;\n    bottom: 40px;\n    top: auto;\n    margin: 0;\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-volume-control {\n  display: none;\n}\n.VideoModal-module_video_player__DO5x- .vjs-mute-control {\n  width: 24px;\n  height: 24px;\n  margin-top: 12px;\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.522 7.22803C21.1496 7.85416 21.6475 8.59793 21.9872 9.41676C22.3269 10.2356 22.5018 11.1134 22.5018 11.9999C22.5018 12.8864 22.3269 13.7642 21.9872 14.583C21.6475 15.4019 21.1496 16.1456 20.522 16.7718" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.5 15.75H3C2.80109 15.75 2.61032 15.671 2.46967 15.5303C2.32902 15.3897 2.25 15.1989 2.25 15V9C2.25 8.80109 2.32902 8.61032 2.46967 8.46967C2.61032 8.32902 2.80109 8.25 3 8.25H7.5L14.25 3V21L7.5 15.75Z" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.5 8.25V15.75" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.8687 9.88135C18.1476 10.1592 18.3689 10.4894 18.5199 10.853C18.6709 11.2166 18.7486 11.6064 18.7486 12.0001C18.7486 12.3938 18.6709 12.7836 18.5199 13.1472C18.3689 13.5108 18.1476 13.841 17.8687 14.1188" stroke="white" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n.VideoModal-module_video_player__DO5x- .vjs-mute-control.vjs-vol-0 {\n  background-image: url(\'data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5215 7.22815C21.1491 7.85428 21.647 8.59805 21.9867 9.41688C22.3264 10.2357 22.5013 11.1135 22.5013 12C22.5013 12.8865 22.3264 13.7643 21.9867 14.5832C21.647 15.402 21.1491 16.1458 20.5215 16.7719" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.5 8.25V15.75" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.8691 9.88123C18.1481 10.1591 18.3694 10.4893 18.5204 10.8529C18.6714 11.2164 18.7491 11.6063 18.7491 12C18.7491 12.3937 18.6714 12.7835 18.5204 13.1471C18.3694 13.5107 18.1481 13.8409 17.8691 14.1187" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.5 3.75L19.5 20.25" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.25 14.475V21L7.5 15.75H3C2.80109 15.75 2.61032 15.671 2.46967 15.5303C2.32902 15.3897 2.25 15.1989 2.25 15V8.99999C2.25 8.80108 2.32902 8.61031 2.46967 8.46966C2.61032 8.32901 2.80109 8.24999 3 8.24999H7.5L8.1375 7.75311" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.5186 5.90625L14.2498 3V10.0125" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n}\n.VideoModal-module_video_player__DO5x- .vjs-mute-control .vjs-icon-placeholder {\n  display: none !important;\n}\n.VideoModal-module_video_player__DO5x- .vjs-progress-control {\n  position: absolute;\n  bottom: 12px !important;\n  top: auto !important;\n  height: 0.5em !important;\n  width: 90% !important;\n  left: 5% !important;\n  border-radius: 5px;\n  background: #636a71;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-progress-control {\n    bottom: 80px !important;\n    width: calc(100% - 48px) !important;\n    left: 24px !important;\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-progress-control:hover .vjs-slider-bar:after {\n  position: absolute;\n  bottom: -3.5px !important;\n  right: -7px;\n  display: block;\n  content: "";\n  width: 14px;\n  height: 14px;\n  border-radius: 7px;\n  background: #0ab6ff;\n  box-shadow: -2px 0px 4px rgba(26, 26, 26, 0.25);\n}\n.VideoModal-module_video_player__DO5x- .vjs-progress-holder {\n  border-radius: 5px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-load-progress {\n  background: #cecece;\n  border-radius: 5px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-load-progressdiv {\n  border-radius: 5px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-time-tooltip {\n  padding: 6px 8px 5px 8px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-slider-bar {\n  background: #0ab6ff;\n  border-radius: 5px;\n}\n.VideoModal-module_video_player__DO5x- .vjs-slider-bar:after {\n  position: absolute;\n  bottom: -3.5px !important;\n  right: -7px;\n  display: block;\n  content: "";\n  width: 14px;\n  height: 14px;\n  border-radius: 7px;\n  background: #0ab6ff;\n  box-shadow: -2px 0px 4px rgba(26, 26, 26, 0.25);\n}\n.VideoModal-module_video_player__DO5x- .vjs-current-time {\n  display: block !important;\n  position: absolute;\n  bottom: 32px;\n  height: 15px;\n  left: 5%;\n  margin-left: 0 !important;\n  padding-left: 0;\n  font-family: "protipo-narrow";\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15px;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-current-time {\n    left: 24px;\n    bottom: 100px;\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-duration {\n  display: block !important;\n  position: absolute;\n  bottom: 32px;\n  right: 5%;\n  text-align: right;\n  padding-right: 0;\n  height: 15px;\n  font-family: "protipo-narrow";\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15px;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-duration {\n    right: 24px;\n    bottom: 100px;\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-time-divider {\n  display: none;\n}\n.VideoModal-module_video_player__DO5x- .vjs-title-bar {\n  display: none;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_player__DO5x- .vjs-title-bar {\n    display: block;\n    background: transparent !important;\n    padding: 24px 24px 0 24px;\n  }\n}\n.VideoModal-module_video_player__DO5x- .vjs-title-bar-title {\n  font-family: "protipo-narrow";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 24px;\n  color: white !important;\n  position: relative;\n  z-index: 2;\n}\n.VideoModal-module_video_player__DO5x- .vjs-title-bar-description {\n  font-family: "protipo-narrow";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 18px;\n  color: white !important;\n  position: relative;\n  z-index: 2;\n}\n.VideoModal-module_video_player__DO5x- .iris-upnext {\n  display: none !important;\n}\n\n.VideoModal-module_video_title__WEpw6 {\n  font-family: "protipo-narrow";\n  font-weight: 600;\n  margin: 0;\n  font-size: 20px;\n  line-height: 25px;\n  color: white;\n}\n\n.VideoModal-module_video_subtitle__plSSI {\n  font-family: "roboto", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #ced4da;\n  margin: 8px 0 0 0;\n}\n\n.VideoModal-module_video_info_container__fpIoN {\n  padding: 16px 16px 0 16px;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_info_container__fpIoN {\n    display: none;\n  }\n}\n\n.VideoModal-module_team_info_sponsor_container__els-L {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding-right: calc(50% - 490px);\n}\n@media (min-width: 768px) {\n  .VideoModal-module_team_info_sponsor_container__els-L {\n    flex-direction: row;\n  }\n}\n\n.VideoModal-module_teams_container__29e4r {\n  display: flex;\n  flex-direction: column;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_teams_container__29e4r {\n    flex-direction: row;\n  }\n}\n\n.VideoModal-module_sponsor_container__gtVSA {\n  padding-left: 16px;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_sponsor_container__gtVSA {\n    padding-top: 8px;\n    margin-right: auto;\n  }\n}\n\n.VideoModal-module_nextup_video_container__rPaKD {\n  display: none;\n  flex-direction: row;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_nextup_video_container__rPaKD {\n    display: flex;\n    height: 64px;\n    padding-top: 12px;\n    padding-right: 16px;\n  }\n}\n@media (min-width: 992px) {\n  .VideoModal-module_nextup_video_container__rPaKD {\n    padding-right: 0;\n  }\n}\n\n.VideoModal-module_nextup_text__5Y-Yl {\n  text-align: right;\n  color: white;\n  font-size: 12px;\n  padding-right: 12px;\n  font-family: "protipo-narrow";\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.VideoModal-module_nextup_video_title__dg7DS {\n  color: #ced4da;\n  text-align: right;\n  font-size: 11px;\n  padding-right: 12px;\n  font-family: "protipo-narrow";\n  font-weight: 500;\n  line-height: 14px;\n  width: 200px;\n  height: 28px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.VideoModal-module_nextup_video_thumbnail__bgxgw {\n  width: 82px;\n  height: 44px;\n  object-fit: cover;\n  border-radius: 4px;\n  border: 1px solid white;\n  box-sizing: content-box;\n}\n\n.VideoModal-module_team_info_container__Z1HYr {\n  padding: 12px 16px 0 16px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n@media (min-width: 360px) {\n  .VideoModal-module_team_info_container__Z1HYr {\n    justify-content: flex-start;\n    padding-left: 16px;\n  }\n}\n@media (min-width: 992px) {\n  .VideoModal-module_team_info_container__Z1HYr {\n    padding-left: 0;\n  }\n}\n.VideoModal-module_team_info_container__Z1HYr .VideoModal-module_team_logo__clko9 {\n  padding: 9px;\n  width: 48px;\n  height: 48px;\n  object-fit: cover;\n  background-color: white;\n  border-radius: 50%;\n  margin-right: 16px;\n}\n.VideoModal-module_team_info_container__Z1HYr .VideoModal-module_team_name__BBy7o {\n  font-family: "protipo-narrow";\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n  white-space: nowrap;\n  text-transform: uppercase;\n  color: white;\n}\n.VideoModal-module_team_info_container__Z1HYr .VideoModal-module_button_wrapper__pNE4p {\n  margin-left: 12px;\n}\n\n.VideoModal-module_scrollable_container__bi-P1 {\n  background-color: #0b223a;\n  width: 100%;\n  overflow-x: scroll;\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none; /* Firefox */\n}\n.VideoModal-module_scrollable_container__bi-P1::-webkit-scrollbar {\n  display: none; /* Safari and Chrome */\n}\n@media (min-width: 992px) {\n  .VideoModal-module_scrollable_container__bi-P1 {\n    background-color: transparent;\n    overflow: visible;\n    padding-left: calc(50% - 490px);\n    padding-right: calc(50% - 490px);\n  }\n}\n@media only screen and (max-height: 575.98px) and (orientation: landscape) {\n  .VideoModal-module_scrollable_container__bi-P1 {\n    display: none;\n  }\n}\n\n.VideoModal-module_tags_container__ye1b8 {\n  margin-top: 15px;\n  padding: 15px 16px 0px 16px;\n  position: sticky;\n  top: -1px;\n  background-color: #0b223a;\n  z-index: 2;\n}\n.VideoModal-module_tags_container__ye1b8.VideoModal-module_pinned__Jurv3 {\n  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.3);\n}\n@media (min-width: 992px) {\n  .VideoModal-module_tags_container__ye1b8 {\n    background-color: transparent;\n    margin-top: 8px;\n    padding-left: 0;\n  }\n}\n.VideoModal-module_tags_container__ye1b8 .VideoModal-module_tag__fuAMC {\n  border: 1px solid #669ed4;\n  margin-right: 10px;\n  cursor: pointer;\n  color: white;\n  padding: 5px 16px;\n  display: inline-block;\n  cursor: pointer;\n  border-radius: 15px;\n  font-family: "protipo-narrow";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  text-align: center;\n  white-space: nowrap;\n}\n.VideoModal-module_tags_container__ye1b8 .VideoModal-module_tag__fuAMC.VideoModal-module_selected__FedL6 {\n  background: white;\n  color: #005eb8;\n}\n\n.VideoModal-module_recommended_videos_container__uhybo {\n  margin-top: 12px;\n  padding: 15px 38px 0 38px;\n  flex: 1;\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none; /* Firefox */\n  overflow: visible;\n}\n.VideoModal-module_recommended_videos_container__uhybo::-webkit-scrollbar {\n  display: none; /* Safari and Chrome */\n}\n@media (min-width: 768px) {\n  .VideoModal-module_recommended_videos_container__uhybo {\n    display: flex;\n    flex-direction: row;\n    padding-left: 16px;\n    overflow-x: scroll;\n  }\n}\n@media (min-width: 992px) {\n  .VideoModal-module_recommended_videos_container__uhybo {\n    width: 100vw;\n    margin-left: calc(-1 * (50vw - 482px));\n    padding-left: calc(50vw - 482px);\n  }\n}\n\n.VideoModal-module_recommended_video_wrapper__GC-oJ {\n  display: block;\n  position: relative;\n  padding-bottom: 28px;\n  transition: opacity 0.2s ease-in-out;\n  cursor: pointer;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_recommended_video_wrapper__GC-oJ {\n    width: 216px;\n    scroll-snap-align: start;\n  }\n}\n.VideoModal-module_recommended_video_wrapper__GC-oJ:hover {\n  opacity: 0.6;\n}\n\n.VideoModal-module_recommended_video_spacer__dHjsf:after {\n  content: "";\n  display: block;\n  width: 200px;\n  height: 100px;\n}\n\n.VideoModal-module_ad_wrapper__bC-4B {\n  display: flex;\n  padding-bottom: 28px;\n  width: 100%;\n  justify-content: center;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_ad_wrapper__bC-4B {\n    display: none;\n  }\n}\n\n.VideoModal-module_recommended_video_thumbnail__NAngp {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 1.77;\n  object-fit: cover;\n  border-radius: 10px;\n  transition: opacity 0.4s ease-in-out;\n  box-sizing: content-box;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_recommended_video_thumbnail__NAngp {\n    width: 200px;\n    aspect-ratio: 1.77;\n    border-radius: 4px;\n    border: solid white 1px;\n  }\n}\n.VideoModal-module_recommended_video_thumbnail__NAngp.VideoModal-module_playing_indicator__vq9U0 {\n  position: absolute;\n  top: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-family: "protipo-narrow";\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n  color: white;\n  background-color: transparent;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_recommended_video_thumbnail__NAngp.VideoModal-module_playing_indicator__vq9U0 {\n    width: 200px;\n    aspect-ratio: 1.77;\n    border-radius: 4px;\n    border: solid white 1px;\n  }\n}\n.VideoModal-module_recommended_video_thumbnail__NAngp.VideoModal-module_playing__8TsiY {\n  background-color: rgba(6, 25, 47, 0.96);\n}\n\n.VideoModal-module_recommended_video_title__CzdDl {\n  font-family: "roboto", sans-serif;\n  color: white;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 20px;\n  margin-top: 12px;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_recommended_video_title__CzdDl {\n    margin-top: 4px;\n    margin-right: 16px;\n    width: 200px;\n    overflow: hidden;\n    height: 20px;\n    line-height: 20px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    font-family: "protipo-narrow";\n    font-size: 12px;\n    font-weight: 700;\n  }\n}\n\n.VideoModal-module_recommended_video_subtitle__-29zA {\n  font-family: "roboto", sans-serif;\n  color: #ced4da;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  margin-top: 2px;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_recommended_video_subtitle__-29zA {\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 15px;\n    margin-top: 0px;\n  }\n}\n\n.VideoModal-module_recommended_video_duration__vDsKt {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  padding: 4px 8px;\n  padding-left: 24px;\n  color: white;\n  height: 24px;\n  background-color: #005eb8;\n  border-radius: 4px;\n  font-family: "roboto", sans-serif;\n  font-size: 14px;\n  line-height: 16px;\n  font-style: normal;\n  font-weight: 400;\n}\n.VideoModal-module_recommended_video_duration__vDsKt:before {\n  position: absolute;\n  left: 8px;\n  top: 5px;\n  content: " ";\n  width: 12px;\n  height: 12px;\n  background-image: url(\'data:image/svg+xml,<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.40202 5.66199C8.54172 5.75278 8.65653 5.87703 8.73601 6.02347C8.81549 6.1699 8.85712 6.33387 8.85712 6.50049C8.85712 6.6671 8.81549 6.83107 8.73601 6.97751C8.65653 7.12394 8.54172 7.2482 8.40202 7.33899L3.54502 10.5C3.39412 10.5981 3.21955 10.6536 3.03971 10.6608C2.85987 10.6679 2.68144 10.6264 2.52324 10.5406C2.36504 10.4548 2.23292 10.3279 2.14083 10.1732C2.04875 10.0186 2.0001 9.84196 2.00002 9.66199L2.00002 3.34299C1.99919 3.16259 2.04719 2.98532 2.13891 2.82998C2.23063 2.67463 2.36267 2.54699 2.52104 2.46059C2.6794 2.37418 2.85819 2.33222 3.03846 2.33916C3.21873 2.34609 3.39376 2.40167 3.54502 2.49999L8.40202 5.66199Z" fill="white"/></svg>\');\n}\n\n.VideoModal-module_video_loading_wrapper__Y8caz {\n  margin-bottom: 32px;\n  width: 100%;\n  height: auto;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_video_loading_wrapper__Y8caz {\n    width: 200px;\n    margin-right: 16px;\n  }\n}\n\n.VideoModal-module_video_container__MC9b2 {\n  position: relative;\n}\n@media only screen and (max-height: 575.98px) and (orientation: landscape) {\n  .VideoModal-module_video_container__MC9b2 {\n    height: 100%;\n    max-width: calc(100% - 140px);\n    aspect-ratio: 16/9;\n    margin: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.VideoModal-module_recommended_videos_wrapper__HYvzK {\n  position: relative;\n  overflow: visible;\n}\n@media (min-width: 768px) {\n  .VideoModal-module_recommended_videos_wrapper__HYvzK {\n    overflow-x: visible;\n  }\n}\n\n.VideoModal-module_scroll_back_button_wrapper__SG4Iz {\n  display: none;\n  position: absolute;\n  bottom: 105px;\n  transition: opacity 0.2s ease-in-out;\n}\n.VideoModal-module_scroll_back_button_wrapper__SG4Iz.VideoModal-module_disabled__1w5qK {\n  opacity: 0;\n  cursor: not-allowed;\n}\n@media (min-width: 992px) {\n  .VideoModal-module_scroll_back_button_wrapper__SG4Iz {\n    display: block;\n  }\n}\n\n.VideoModal-module_scroll_forward_button_wrapper__8rUDP {\n  display: none;\n  position: absolute;\n  bottom: 105px;\n  transition: opacity 0.2s ease-in-out;\n}\n.VideoModal-module_scroll_forward_button_wrapper__8rUDP.VideoModal-module_disabled__1w5qK {\n  opacity: 0;\n}\n@media (min-width: 992px) {\n  .VideoModal-module_scroll_forward_button_wrapper__8rUDP {\n    display: block;\n    right: calc(100% - 980px);\n  }\n}\n\n.VideoModal-module_button__Sf7P1 {\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n}\n\n@keyframes VideoModal-module_fadeIn__9B7zt {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes VideoModal-module_fadeOut__Zhyhp {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}');
var Sn = {
  LoadingSkeleton__cont: "LoadingSkeleton-module_LoadingSkeleton__cont__voTNN",
  LoadingSkeleton__animated: "LoadingSkeleton-module_LoadingSkeleton__animated__wxmIl",
  shine: "LoadingSkeleton-module_shine__x0Cxs",
  grey: "LoadingSkeleton-module_grey__0i2c3",
  snBlue: "LoadingSkeleton-module_snBlue__Rn0Ew"
};
Vn(".LoadingSkeleton-module_LoadingSkeleton__cont__voTNN {\n    background-color: #ddd;\n}\n\n.LoadingSkeleton-module_LoadingSkeleton__animated__wxmIl {\n    background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n    border-radius: 5px;\n    background-size: 400% 100%;\n    animation-name: LoadingSkeleton-module_shine__x0Cxs;\n    animation-duration: 3s;\n    animation-iteration-count: infinite;\n    animation-timing-function: linear;\n\n    &.LoadingSkeleton-module_grey__0i2c3 {\n        background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n        background-size: 400% 100%;\n    }\n    &.LoadingSkeleton-module_snBlue__Rn0Ew {\n        background: linear-gradient(110deg, #156bac 8%, #156bac99 18%, #156bac 33%);\n        background-size: 400% 100%;\n    }\n}\n\n@keyframes LoadingSkeleton-module_shine__x0Cxs {\n    to {\n        background-position-x: -400%;\n    }\n}\n");
var In = function In(n) {
  var t = n.width,
    o = n.height,
    r = n.aspectRatio,
    i = n.opacity,
    a = n.round,
    l = n.animate,
    d = n.borderRadius,
    s = n.marginTop,
    c = n.color;
  return e.createElement("div", {
    className: En(Sn.LoadingSkeleton__cont, l ? Sn.LoadingSkeleton__animated : "", Sn[c]),
    style: {
      width: t,
      height: o,
      aspectRatio: r,
      marginTop: s,
      opacity: i,
      borderRadius: a ? "50%" : d
    }
  });
};
In.propTypes = {
  width: Mn.oneOfType([Mn.number, Mn.string]),
  height: Mn.oneOfType([Mn.number, Mn.string]),
  round: Mn.bool,
  animate: Mn.bool,
  borderRadius: Mn.number,
  color: Mn.oneOf(["grey", "snBlue"])
}, In.defaultProps = {
  width: 32,
  height: 12,
  round: !1,
  animate: !0,
  borderRadius: 0,
  color: "grey"
};
var Dn = {
  button: "Button-module_button__18Bed",
  shadow: "Button-module_shadow__cwtDe",
  leftArrow: "Button-module_leftArrow__MIaEz",
  inverted: "Button-module_inverted__bGHmY",
  rightArrow: "Button-module_rightArrow__iam-1",
  favorite: "Button-module_favorite__ABC9q",
  selected: "Button-module_selected__8rUFd"
};
Vn('.Button-module_button__18Bed {\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  border-radius: 4px;\n  cursor: pointer;\n  width: 35px;\n  height: 35px;\n  background-repeat: no-repeat;\n  background-position: center;\n  transition: background-color 0.2s ease-in-out;\n}\n\n.Button-module_shadow__cwtDe {\n  box-shadow: 0 3px 12px rgba(6, 25, 47, 0.5);\n}\n\n.Button-module_leftArrow__MIaEz {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none" transform="rotate(180)"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n.Button-module_leftArrow__MIaEz.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none" transform="rotate(180)"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_leftArrow__MIaEz:hover {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none" transform="rotate(180)"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_leftArrow__MIaEz:hover.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none" transform="rotate(180)"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n\n.Button-module_rightArrow__iam-1 {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n.Button-module_rightArrow__iam-1.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_rightArrow__iam-1:hover {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_rightArrow__iam-1:hover.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="8" height="15" viewBox="0 0 8 15" fill="none"><path d="M1.16667 1.66732L7 7.50065L1.16667 13.334" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n\n.Button-module_favorite__ABC9q {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00342 2.45003C9.14882 2.3482 9.32203 2.29358 9.49954 2.29358C9.67705 2.29358 9.85027 2.3482 9.99566 2.45003C10.1398 2.551 10.2497 2.69353 10.3107 2.85855L11.8586 6.75642C11.879 6.8115 11.915 6.85946 11.9622 6.89439C12.0095 6.92932 12.0658 6.94974 12.1245 6.95315L12.1262 6.95325L16.2747 7.22045C17.0838 7.27299 17.3733 8.29507 16.774 8.79309L13.5961 11.4437L13.5952 11.4444C13.5472 11.4841 13.5114 11.5365 13.4919 11.5957C13.4725 11.6546 13.47 11.7178 13.4848 11.778L13.485 11.7787L14.5112 15.813C14.7022 16.5669 13.8916 17.2228 13.2026 16.7882L9.65816 14.5378C9.6108 14.5077 9.55567 14.4916 9.49954 14.4916C9.44341 14.4916 9.38845 14.5075 9.34108 14.5377L6.04351 16.6259C5.26767 17.1196 4.34661 16.3748 4.56522 15.5179L5.51407 11.7787L5.51422 11.7781C5.52905 11.7178 5.52661 11.6546 5.50719 11.5957C5.4877 11.5365 5.4519 11.4841 5.40391 11.4444L5.40299 11.4437L2.22532 8.79326C1.62602 8.29524 1.91514 7.273 2.72429 7.22046L6.87461 6.95315C6.93325 6.94974 6.98963 6.92932 7.03685 6.89439C7.08408 6.85946 7.1201 6.81152 7.14053 6.75645L7.14277 6.75041L8.68835 2.85855C8.74935 2.69353 8.85925 2.551 9.00342 2.45003Z" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n.Button-module_favorite__ABC9q.Button-module_selected__8rUFd {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.09717 0.156453C7.24257 0.0546229 7.41578 0 7.59329 0C7.7708 0 7.94402 0.0546231 8.08941 0.156453C8.23358 0.257421 8.34348 0.399951 8.40448 0.564975L9.95237 4.46284C9.9728 4.51792 10.0088 4.56588 10.056 4.60081C10.1032 4.63574 10.1596 4.65616 10.2182 4.65957L10.22 4.65968L14.3684 4.92687C15.1776 4.97941 15.467 6.00149 14.8677 6.49951L11.6898 9.15008L11.6889 9.15085C11.6409 9.19053 11.6051 9.24296 11.5856 9.3021C11.5662 9.36101 11.5638 9.4242 11.5786 9.48443L11.5788 9.48512L12.6049 13.5195C12.7959 14.2733 11.9853 14.9292 11.2964 14.4946L7.75191 12.2442C7.70455 12.2141 7.64942 12.198 7.59329 12.198C7.53716 12.198 7.48219 12.214 7.43483 12.2441L4.13726 14.3323C3.36142 14.826 2.44036 14.0812 2.65897 13.2243L3.60782 9.48512L3.60797 9.4845C3.6228 9.42425 3.62036 9.36104 3.60094 9.3021C3.58145 9.24296 3.54565 9.19053 3.49766 9.15085L3.49674 9.15008L0.319069 6.49968C-0.280231 6.00166 0.00888562 4.97942 0.818035 4.92688L4.96836 4.65957C5.027 4.65616 5.08338 4.63574 5.1306 4.60081C5.17783 4.56588 5.21385 4.51794 5.23428 4.46287L5.23652 4.45683L6.7821 0.564975C6.8431 0.399952 6.953 0.257422 7.09717 0.156453Z" fill="%23005EB8"/></svg>\');\n}\n.Button-module_favorite__ABC9q.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00342 2.45003C9.14882 2.3482 9.32203 2.29358 9.49954 2.29358C9.67705 2.29358 9.85027 2.3482 9.99566 2.45003C10.1398 2.551 10.2497 2.69353 10.3107 2.85855L11.8586 6.75642C11.879 6.8115 11.915 6.85946 11.9622 6.89439C12.0095 6.92932 12.0658 6.94974 12.1245 6.95315L12.1262 6.95325L16.2747 7.22045C17.0838 7.27299 17.3733 8.29507 16.774 8.79309L13.5961 11.4437L13.5952 11.4444C13.5472 11.4841 13.5114 11.5365 13.4919 11.5957C13.4725 11.6546 13.47 11.7178 13.4848 11.778L13.485 11.7787L14.5112 15.813C14.7022 16.5669 13.8916 17.2228 13.2026 16.7882L9.65816 14.5378C9.6108 14.5077 9.55567 14.4916 9.49954 14.4916C9.44341 14.4916 9.38845 14.5075 9.34108 14.5377L6.04351 16.6259C5.26767 17.1196 4.34661 16.3748 4.56522 15.5179L5.51407 11.7787L5.51422 11.7781C5.52905 11.7178 5.52661 11.6546 5.50719 11.5957C5.4877 11.5365 5.4519 11.4841 5.40391 11.4444L5.40299 11.4437L2.22532 8.79326C1.62602 8.29524 1.91514 7.273 2.72429 7.22046L6.87461 6.95315C6.93325 6.94974 6.98963 6.92932 7.03685 6.89439C7.08408 6.85946 7.1201 6.81152 7.14053 6.75645L7.14277 6.75041L8.68835 2.85855C8.74935 2.69353 8.85925 2.551 9.00342 2.45003Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_favorite__ABC9q.Button-module_selected__8rUFd.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.09717 0.156453C7.24257 0.0546229 7.41578 0 7.59329 0C7.7708 0 7.94402 0.0546231 8.08941 0.156453C8.23358 0.257421 8.34348 0.399951 8.40448 0.564975L9.95237 4.46284C9.9728 4.51792 10.0088 4.56588 10.056 4.60081C10.1032 4.63574 10.1596 4.65616 10.2182 4.65957L10.22 4.65968L14.3684 4.92687C15.1776 4.97941 15.467 6.00149 14.8677 6.49951L11.6898 9.15008L11.6889 9.15085C11.6409 9.19053 11.6051 9.24296 11.5856 9.3021C11.5662 9.36101 11.5638 9.4242 11.5786 9.48443L11.5788 9.48512L12.6049 13.5195C12.7959 14.2733 11.9853 14.9292 11.2964 14.4946L7.75191 12.2442C7.70455 12.2141 7.64942 12.198 7.59329 12.198C7.53716 12.198 7.48219 12.214 7.43483 12.2441L4.13726 14.3323C3.36142 14.826 2.44036 14.0812 2.65897 13.2243L3.60782 9.48512L3.60797 9.4845C3.6228 9.42425 3.62036 9.36104 3.60094 9.3021C3.58145 9.24296 3.54565 9.19053 3.49766 9.15085L3.49674 9.15008L0.319069 6.49968C-0.280231 6.00166 0.00888562 4.97942 0.818035 4.92688L4.96836 4.65957C5.027 4.65616 5.08338 4.63574 5.1306 4.60081C5.17783 4.56588 5.21385 4.51794 5.23428 4.46287L5.23652 4.45683L6.7821 0.564975C6.8431 0.399952 6.953 0.257422 7.09717 0.156453Z" fill="white"/></svg>\');\n}\n.Button-module_favorite__ABC9q:hover {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00342 2.45003C9.14882 2.3482 9.32203 2.29358 9.49954 2.29358C9.67705 2.29358 9.85027 2.3482 9.99566 2.45003C10.1398 2.551 10.2497 2.69353 10.3107 2.85855L11.8586 6.75642C11.879 6.8115 11.915 6.85946 11.9622 6.89439C12.0095 6.92932 12.0658 6.94974 12.1245 6.95315L12.1262 6.95325L16.2747 7.22045C17.0838 7.27299 17.3733 8.29507 16.774 8.79309L13.5961 11.4437L13.5952 11.4444C13.5472 11.4841 13.5114 11.5365 13.4919 11.5957C13.4725 11.6546 13.47 11.7178 13.4848 11.778L13.485 11.7787L14.5112 15.813C14.7022 16.5669 13.8916 17.2228 13.2026 16.7882L9.65816 14.5378C9.6108 14.5077 9.55567 14.4916 9.49954 14.4916C9.44341 14.4916 9.38845 14.5075 9.34108 14.5377L6.04351 16.6259C5.26767 17.1196 4.34661 16.3748 4.56522 15.5179L5.51407 11.7787L5.51422 11.7781C5.52905 11.7178 5.52661 11.6546 5.50719 11.5957C5.4877 11.5365 5.4519 11.4841 5.40391 11.4444L5.40299 11.4437L2.22532 8.79326C1.62602 8.29524 1.91514 7.273 2.72429 7.22046L6.87461 6.95315C6.93325 6.94974 6.98963 6.92932 7.03685 6.89439C7.08408 6.85946 7.1201 6.81152 7.14053 6.75645L7.14277 6.75041L8.68835 2.85855C8.74935 2.69353 8.85925 2.551 9.00342 2.45003Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: #005eb8;\n}\n.Button-module_favorite__ABC9q:hover.Button-module_selected__8rUFd {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.09717 0.156453C7.24257 0.0546229 7.41578 0 7.59329 0C7.7708 0 7.94402 0.0546231 8.08941 0.156453C8.23358 0.257421 8.34348 0.399951 8.40448 0.564975L9.95237 4.46284C9.9728 4.51792 10.0088 4.56588 10.056 4.60081C10.1032 4.63574 10.1596 4.65616 10.2182 4.65957L10.22 4.65968L14.3684 4.92687C15.1776 4.97941 15.467 6.00149 14.8677 6.49951L11.6898 9.15008L11.6889 9.15085C11.6409 9.19053 11.6051 9.24296 11.5856 9.3021C11.5662 9.36101 11.5638 9.4242 11.5786 9.48443L11.5788 9.48512L12.6049 13.5195C12.7959 14.2733 11.9853 14.9292 11.2964 14.4946L7.75191 12.2442C7.70455 12.2141 7.64942 12.198 7.59329 12.198C7.53716 12.198 7.48219 12.214 7.43483 12.2441L4.13726 14.3323C3.36142 14.826 2.44036 14.0812 2.65897 13.2243L3.60782 9.48512L3.60797 9.4845C3.6228 9.42425 3.62036 9.36104 3.60094 9.3021C3.58145 9.24296 3.54565 9.19053 3.49766 9.15085L3.49674 9.15008L0.319069 6.49968C-0.280231 6.00166 0.00888562 4.97942 0.818035 4.92688L4.96836 4.65957C5.027 4.65616 5.08338 4.63574 5.1306 4.60081C5.17783 4.56588 5.21385 4.51794 5.23428 4.46287L5.23652 4.45683L6.7821 0.564975C6.8431 0.399952 6.953 0.257422 7.09717 0.156453Z" fill="white"/></svg>\');\n}\n.Button-module_favorite__ABC9q:hover.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00342 2.45003C9.14882 2.3482 9.32203 2.29358 9.49954 2.29358C9.67705 2.29358 9.85027 2.3482 9.99566 2.45003C10.1398 2.551 10.2497 2.69353 10.3107 2.85855L11.8586 6.75642C11.879 6.8115 11.915 6.85946 11.9622 6.89439C12.0095 6.92932 12.0658 6.94974 12.1245 6.95315L12.1262 6.95325L16.2747 7.22045C17.0838 7.27299 17.3733 8.29507 16.774 8.79309L13.5961 11.4437L13.5952 11.4444C13.5472 11.4841 13.5114 11.5365 13.4919 11.5957C13.4725 11.6546 13.47 11.7178 13.4848 11.778L13.485 11.7787L14.5112 15.813C14.7022 16.5669 13.8916 17.2228 13.2026 16.7882L9.65816 14.5378C9.6108 14.5077 9.55567 14.4916 9.49954 14.4916C9.44341 14.4916 9.38845 14.5075 9.34108 14.5377L6.04351 16.6259C5.26767 17.1196 4.34661 16.3748 4.56522 15.5179L5.51407 11.7787L5.51422 11.7781C5.52905 11.7178 5.52661 11.6546 5.50719 11.5957C5.4877 11.5365 5.4519 11.4841 5.40391 11.4444L5.40299 11.4437L2.22532 8.79326C1.62602 8.29524 1.91514 7.273 2.72429 7.22046L6.87461 6.95315C6.93325 6.94974 6.98963 6.92932 7.03685 6.89439C7.08408 6.85946 7.1201 6.81152 7.14053 6.75645L7.14277 6.75041L8.68835 2.85855C8.74935 2.69353 8.85925 2.551 9.00342 2.45003Z" stroke="%23005EB8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>\');\n  background-color: white;\n}\n.Button-module_favorite__ABC9q:hover.Button-module_selected__8rUFd.Button-module_inverted__bGHmY {\n  background-image: url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.09717 0.156453C7.24257 0.0546229 7.41578 0 7.59329 0C7.7708 0 7.94402 0.0546231 8.08941 0.156453C8.23358 0.257421 8.34348 0.399951 8.40448 0.564975L9.95237 4.46284C9.9728 4.51792 10.0088 4.56588 10.056 4.60081C10.1032 4.63574 10.1596 4.65616 10.2182 4.65957L10.22 4.65968L14.3684 4.92687C15.1776 4.97941 15.467 6.00149 14.8677 6.49951L11.6898 9.15008L11.6889 9.15085C11.6409 9.19053 11.6051 9.24296 11.5856 9.3021C11.5662 9.36101 11.5638 9.4242 11.5786 9.48443L11.5788 9.48512L12.6049 13.5195C12.7959 14.2733 11.9853 14.9292 11.2964 14.4946L7.75191 12.2442C7.70455 12.2141 7.64942 12.198 7.59329 12.198C7.53716 12.198 7.48219 12.214 7.43483 12.2441L4.13726 14.3323C3.36142 14.826 2.44036 14.0812 2.65897 13.2243L3.60782 9.48512L3.60797 9.4845C3.6228 9.42425 3.62036 9.36104 3.60094 9.3021C3.58145 9.24296 3.54565 9.19053 3.49766 9.15085L3.49674 9.15008L0.319069 6.49968C-0.280231 6.00166 0.00888562 4.97942 0.818035 4.92688L4.96836 4.65957C5.027 4.65616 5.08338 4.63574 5.1306 4.60081C5.17783 4.56588 5.21385 4.51794 5.23428 4.46287L5.23652 4.45683L6.7821 0.564975C6.8431 0.399952 6.953 0.257422 7.09717 0.156453Z" fill="%23005EB8"/></svg>\');\n}');
var Bn = function Bn(n) {
  var t = n.onClick,
    o = n.icon,
    r = n.dropShadow,
    i = n.invertColors,
    a = n.selected,
    l = r ? Dn.shadow : "",
    d = i ? Dn.inverted : "",
    s = a ? Dn.selected : "";
  return e.createElement("button", {
    className: En(Dn.button, Dn[o], l, d, s),
    onClick: t
  });
};
Bn.propTypes = {
  onClick: kn.PropTypes.function,
  icon: kn.PropTypes.string.isRequired,
  dropShadow: kn.PropTypes.bool,
  invertColors: kn.PropTypes.bool,
  selected: kn.PropTypes.bool
}, Bn.defaultProps = {
  dropShadow: !0
};
var Tn = function Tn(o) {
    var r = o.videos,
      i = void 0 === r ? [] : r,
      a = o.showArrows,
      l = void 0 === a || a,
      d = o.handleVideoClick,
      s = o.playingVideoIndex,
      c = o.adComponent,
      p = u(n(!0), 2),
      m = p[0],
      _ = p[1],
      f = u(n(!1), 2),
      h = f[0],
      g = f[1],
      v = t(null);
    return e.createElement("div", {
      className: Ln.recommended_videos_wrapper
    }, e.createElement("div", {
      ref: v,
      className: Ln.recommended_videos_container,
      onScroll: Nn(function (e) {
        0 === e.target.scrollLeft ? _(!0) : _(!1), e.target.scrollLeft + e.target.clientWidth + 20 >= e.target.scrollWidth ? g(!0) : g(!1);
      })
    }, i.length > 0 && i.map(function (n, t) {
      return e.createElement(e.Fragment, null, 0 !== t && t % 3 == 0 && c && e.createElement("div", {
        className: Ln.ad_wrapper
      }, c), e.createElement("div", {
        key: n.id,
        className: Ln.recommended_video_wrapper,
        onClick: function onClick() {
          return d(t);
        }
      }, e.createElement("img", {
        src: n.image_url_large || n.image_url,
        className: Ln.recommended_video_thumbnail
      }), e.createElement("div", {
        className: En(Ln.recommended_video_thumbnail, Ln.playing_indicator, s === t && Ln.playing)
      }, s === t && "NOW PLAYING", n.duration && s !== t && e.createElement("div", {
        className: Ln.recommended_video_duration
      }, n.duration)), e.createElement("div", {
        className: Ln.recommended_video_title
      }, n.title), e.createElement("div", {
        className: Ln.recommended_video_subtitle
      }, n.subtitle)));
    }), 0 === i.length && e.createElement(e.Fragment, null, e.createElement("div", {
      className: Ln.video_loading_wrapper
    }, e.createElement(In, {
      borderRadius: 8,
      width: "100%",
      height: "auto",
      aspectRatio: 1.77,
      opacity: .2
    }), e.createElement(In, {
      borderRadius: 4,
      width: "100%",
      height: 18,
      opacity: .2,
      marginTop: 12
    }), e.createElement(In, {
      borderRadius: 4,
      width: "80%",
      height: 18,
      opacity: .2,
      marginTop: 4
    })), e.createElement("div", {
      className: Ln.video_loading_wrapper
    }, e.createElement(In, {
      borderRadius: 8,
      width: "100%",
      height: "auto",
      aspectRatio: 1.77,
      opacity: .2
    }), e.createElement(In, {
      borderRadius: 4,
      width: "100%",
      height: 18,
      opacity: .2,
      marginTop: 12
    }), e.createElement(In, {
      borderRadius: 4,
      width: "80%",
      height: 18,
      opacity: .2,
      marginTop: 4
    })), e.createElement("div", {
      className: Ln.video_loading_wrapper
    }, e.createElement(In, {
      borderRadius: 8,
      width: "100%",
      height: "auto",
      aspectRatio: 1.77,
      opacity: .2
    }), e.createElement(In, {
      borderRadius: 4,
      width: "100%",
      height: 18,
      opacity: .2,
      marginTop: 12
    }), e.createElement(In, {
      borderRadius: 4,
      width: "80%",
      height: 18,
      opacity: .2,
      marginTop: 4
    }))), e.createElement("div", {
      className: Ln.recommended_video_spacer
    })), l && i.length > 0 && e.createElement(e.Fragment, null, e.createElement("div", {
      className: En(Ln.scroll_back_button_wrapper, m && Ln.disabled)
    }, e.createElement(Bn, {
      icon: "leftArrow",
      onClick: function onClick() {
        v.current.scrollTo({
          behavior: "smooth",
          left: v.current.scrollLeft - 320
        });
      }
    })), e.createElement("div", {
      className: En(Ln.scroll_forward_button_wrapper, h && Ln.disabled)
    }, e.createElement(Bn, {
      icon: "rightArrow",
      onClick: function onClick() {
        v.current.scrollTo({
          behavior: "smooth",
          left: v.current.scrollLeft + 320
        });
      }
    }))));
  },
  Pn = function Pn(r) {
    var i = r.show,
      l = r.autoplay,
      d = r.irisClientToken,
      m = r.videoID,
      _ = r.accountID,
      f = r.playerID,
      h = r.videoTags,
      g = void 0 === h ? [] : h,
      v = r.videoDataFetchUrl,
      y = r.sponsorComponent,
      w = r.adComponent,
      b = r.onCloseModal,
      x = r.kremerApi,
      C = r.videoControlsInactivityTimeout;
    if (!m) return null;
    var k = t(null),
      M = t(null),
      V = u(n(i), 2),
      L = V[0],
      E = V[1],
      j = u(n(!1), 2),
      O = j[0],
      N = j[1],
      S = u(n(!1), 2),
      I = S[0],
      D = S[1],
      B = u(n([]), 2),
      T = B[0],
      P = B[1],
      A = u(n(null), 2),
      F = A[0],
      R = A[1],
      H = u(n(null), 2),
      z = H[0],
      Z = H[1],
      U = u(n(""), 2),
      $ = U[0],
      Y = U[1],
      q = u(n(0), 2),
      G = q[0],
      J = q[1],
      W = u(n(!1), 2),
      K = W[0],
      Q = W[1],
      X = u(n([]), 2),
      ee = X[0],
      ne = X[1],
      te = u(n(m), 2),
      oe = te[0],
      re = te[1],
      ie = u(n(null), 2),
      ae = ie[0],
      le = ie[1],
      de = u(n(null), 2),
      se = de[0],
      ce = de[1],
      ue = u(n(null), 2),
      pe = ue[0],
      me = ue[1],
      _e = u(n(!1), 2),
      fe = _e[0],
      he = _e[1],
      ge = u(n(null), 2),
      ve = ge[0],
      ye = ge[1],
      we = u(n([]), 2),
      be = we[0],
      xe = we[1],
      Ce = u(n([]), 2),
      ke = Ce[0],
      Me = Ce[1],
      Ve = {
        url: $,
        title: F,
        text: z
      },
      Le = function () {
        var e = a(c().mark(function e(n) {
          var t, o;
          return c().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, fetch("".concat(x, "/preferences"), {
                  method: "GET",
                  headers: {
                    Authorization: "Bearer ".concat(n.flatToken)
                  }
                });
              case 2:
                return t = e.sent, e.next = 5, t.json();
              case 5:
                (o = e.sent) && xe(o.selected);
              case 7:
              case "end":
                return e.stop();
            }
          }, e);
        }));
        return function (n) {
          return e.apply(this, arguments);
        };
      }(),
      Ee = function () {
        var e = a(c().mark(function e() {
          var n, t, o, r;
          return c().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return n = [], e.next = 3, fetch("".concat(x, "/options"));
              case 3:
                return t = e.sent, e.next = 6, t.json();
              case 6:
                o = e.sent, r = Object.keys(o.available.teams), o && r.map(function (e) {
                  var t;
                  null === (t = o.available.teams[e]) || void 0 === t || t.map(function (e) {
                    return n.push(e);
                  });
                }), n.length > 0 && Me(n);
              case 10:
              case "end":
                return e.stop();
            }
          }, e);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }();
    o(function () {
      Ee();
      var e = JSON.parse(localStorage.getItem("favourites")),
        n = JSON.parse(localStorage.getItem("easFlatToken"));
      if (e) {
        var t = e.filter(function (e) {
          return "teams" === e.taxonomy;
        });
        xe(t);
      }
      !e && n && Le(n);
    }, []), o(function () {
      E(i);
    }, [i]), o(function () {
      P([]), R(null), Z(null), Y(""), J(0), Q(!1), ne([]), re(null), le(null), ce(null), me(null), m && (re(m), Ne());
    }, [m]), o(function () {
      T.every(function (e) {
        return e.additionalDataLookedUp;
      }) || je().then(function (e) {
        P(e);
      });
    }, [T]), o(function () {
      Oe(oe);
    }, [oe, be]), o(function () {
      if (0 !== g.length) {
        var e = document.querySelector("#tags_container");
        new IntersectionObserver(function (e) {
          var n = u(e, 1)[0];
          return Q(n.intersectionRatio < 1);
        }, {
          threshold: [1]
        }).observe(e);
      }
    }, [g]), o(function () {
      var e = setInterval(function () {
        window.sn_iris && (clearInterval(e), M.current = window.sn_iris, M.current.addCallback.next(Se), M.current.addCallback.watch(Se), null !== k.current && (k.current.on("ended", Se), k.current.on("playing", Se)), oe && Se());
      }, 200);
      return function () {
        return clearInterval(e);
      };
    }, [m]);
    var je = function () {
        var e = a(c().mark(function e() {
          var n;
          return c().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, Promise.all(T.map(function () {
                  var e = a(c().mark(function e(n) {
                    var t, o, r, i, a;
                    return c().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          if (!n.additionalDataLookedUp) {
                            e.next = 2;
                            break;
                          }
                          return e.abrupt("return", Promise.resolve(n));
                        case 2:
                          return e.next = 4, fetch("".concat(v, "?id=").concat(n.id));
                        case 4:
                          return i = e.sent, e.next = 7, i.json();
                        case 7:
                          return a = e.sent, e.abrupt("return", s(s({}, n), {}, {
                            additionalDataLookedUp: !0,
                            image_url_large: null === (t = a[0]) || void 0 === t ? void 0 : t.bc_video_still_url,
                            subtitle: jn(1e3 * ((null === (o = a[0]) || void 0 === o ? void 0 : o.timestamp) || 0)),
                            duration: On(null === (r = a[0]) || void 0 === r ? void 0 : r.bc_duration)
                          }));
                        case 9:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }));
                  return function (n) {
                    return e.apply(this, arguments);
                  };
                }()));
              case 2:
                return n = e.sent, e.abrupt("return", n);
              case 4:
              case "end":
                return e.stop();
            }
          }, e);
        }));
        return function () {
          return e.apply(this, arguments);
        };
      }(),
      Oe = function () {
        var e = a(c().mark(function e(n) {
          var t, o, r, i, a, l, d, s, u, p, m, _, f;
          return c().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (n) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return R(null), Z(null), ce(null), me(null), e.next = 8, fetch("".concat(v, "?id=").concat(n));
              case 8:
                return l = e.sent, e.next = 11, l.json();
              case 11:
                d = e.sent, (null === (t = d[0]) || void 0 === t ? void 0 : t.teams.length) > 0 && be && ce({
                  name: null === (s = d[0]) || void 0 === s || null === (s = s.teams[0]) || void 0 === s ? void 0 : s.name,
                  logo: null === (u = d[0]) || void 0 === u || null === (u = u.teams[0]) || void 0 === u || null === (u = u.team_logo_url) || void 0 === u ? void 0 : u.small,
                  stats_id: null === (p = d[0]) || void 0 === p || null === (p = p.teams[0]) || void 0 === p ? void 0 : p.stats_id,
                  favourite: !!be.find(function (e) {
                    return e.stats_id === d[0].teams[0].stats_id;
                  })
                }), (null === (o = d[0]) || void 0 === o ? void 0 : o.teams.length) > 1 && be && me({
                  name: null === (m = d[0]) || void 0 === m ? void 0 : m.teams[1].name,
                  logo: null === (_ = d[0]) || void 0 === _ || null === (_ = _.teams[1]) || void 0 === _ || null === (_ = _.team_logo_url) || void 0 === _ ? void 0 : _.small,
                  stats_id: null === (f = d[0]) || void 0 === f || null === (f = f.teams[1]) || void 0 === f ? void 0 : f.stats_id,
                  favourite: !!be.find(function (e) {
                    return e.stats_id === d[0].teams[1].stats_id;
                  })
                }), Y(null === (r = d[0]) || void 0 === r ? void 0 : r.permalink), R(null === (i = d[0]) || void 0 === i ? void 0 : i.post_title), Z(jn(1e3 * ((null === (a = d[0]) || void 0 === a ? void 0 : a.timestamp) || 0)));
              case 17:
              case "end":
                return e.stop();
            }
          }, e);
        }));
        return function (n) {
          return e.apply(this, arguments);
        };
      }(),
      Ne = function Ne(e) {
        for (var n = document.querySelectorAll(".vjs-control"), t = function t(e) {
            return e.stopImmediatePropagation();
          }, o = n.length; o--;) n[o].addEventListener("touchstart", t, !1);
        if (e) k.current = e.ref;else if (!k.current) return;
        var r = null !== window.localStorage.getItem("consent-functional") && "true" === window.localStorage.getItem("consent-functional");
        Xe.isDefined("iris-".concat(d)) ? (k.current.pluginDev && k.current.pluginDev({
          ssl: !0,
          carousel_recs: !0,
          client_token: d,
          campaign_tracking: !0,
          global: "sn_iris",
          perform_player: !1,
          start_up_next: !1,
          end_up_next: !1,
          thumbs_up: !1,
          thumbs_down: !1,
          skip_forward: !0,
          skip_back: !0,
          skip_on_thumbs_down: !1,
          set_cookie: !!r
        }), oe && Se()) : (Xe.ready("iris-".concat(d), function () {
          k.current.pluginDev({
            ssl: !0,
            carousel_recs: !0,
            client_token: d,
            campaign_tracking: !0,
            global: "sn_iris",
            perform_player: !1,
            start_up_next: !1,
            end_up_next: !1,
            thumbs_up: !1,
            thumbs_down: !1,
            skip_forward: !0,
            skip_back: !0,
            skip_on_thumbs_down: !1,
            set_cookie: !!r
          }), oe && Se();
        }), Xe("https://s3.amazonaws.com/iris-playground/cosmos/plugins/iris-bc.adaptive.js", "iris-".concat(d)));
      },
      Se = function Se() {
        var e,
          n,
          t = null === (e = M.current) || void 0 === e ? void 0 : e.getPlaylist(),
          o = null === (n = M.current) || void 0 === n ? void 0 : n.getCurrentIndex();
        J(o), t && (P(function (e) {
          return t.map(function (n, t) {
            var o;
            return n.platform_id === (null === (o = e[t]) || void 0 === o ? void 0 : o.id) && e[t].title ? e[t] : s(s({}, n), {}, {
              id: n.platform_id,
              title: n.title
            });
          });
        }), t.length > o && le(t[o + 1]));
      },
      Ie = function Ie(e) {
        if ("touch" !== e) {
          if ("mouseMove" !== e && "mouseEnter" !== e) {
            if ("mouseLeave" !== e) ;else {
              if (fe) return;
              N(!1);
            }
          } else {
            if (fe) return;
            ve && clearTimeout(ve), N(!0);
            var n = setTimeout(function () {
              N(!1);
            }, C);
            ye(function (e) {
              return e && clearTimeout(e), n;
            });
          }
        } else {
          he(!0), N(function (e) {
            return N(!e);
          });
          var t = setTimeout(function () {
            N(!1);
          }, C);
          ye(function (e) {
            return e && clearTimeout(e), t;
          });
        }
      },
      De = function De(e, n) {
        var t = JSON.parse(localStorage.getItem("easFlatToken")),
          o = JSON.parse(localStorage.getItem("easProfileData"));
        if (e.favourite) {
          var r = be.filter(function (n) {
            return n.stats_id !== e.stats_id;
          });
          null != t && t.flatToken && fetch("".concat(x, "/preferences"), {
            headers: {
              Authorization: "Bearer ".concat(t.flatToken)
            },
            method: "POST",
            body: JSON.stringify({
              guid: o.guid,
              stats_ids: r.map(function (e) {
                return e.stats_id;
              })
            })
          }).then(function (e) {
            return console.error(e);
          }).catch(function (e) {
            return console.error(e);
          }), xe(r), localStorage.setItem("favourites", JSON.stringify(r)), "first" === n ? ce(s(s({}, se), {}, {
            favourite: !1
          })) : me(s(s({}, pe), {}, {
            favourite: !1
          }));
        } else {
          var i = be;
          ke.map(function (n) {
            n.stats_id === e.stats_id && i.push(n);
          }), null != t && t.flatToken && fetch("".concat(x, "/preferences"), {
            headers: {
              Authorization: "Bearer ".concat(t.flatToken)
            },
            method: "POST",
            body: JSON.stringify({
              guid: o.guid,
              stats_ids: i.map(function (e) {
                return e.stats_id;
              })
            })
          }).then(function (e) {
            return console.error(e);
          }).catch(function (e) {
            return console.error(e);
          }), xe(i), localStorage.setItem("favourites", JSON.stringify(i)), "first" === n ? ce(s(s({}, se), {}, {
            favourite: !0
          })) : me(s(s({}, pe), {}, {
            favourite: !0
          }));
        }
      };
    return L ? e.createElement("div", {
      className: En(Ln.modal_container, I ? Ln.fade_out : "")
    }, e.createElement("div", {
      className: Ln.backdrop_container
    }, e.createElement("div", {
      className: Ln.backdrop_logo
    }, e.createElement("img", {
      src: "data:image/svg+xml,%3csvg width='693' height='400' viewBox='0 0 693 400' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M204.934 0C306.692 0 331.741 28.4399 322.607 78.0153L223.979 78.0097C226.07 64.9682 223.195 56.6186 216.936 51.6599C211.199 45.923 201.543 44.6167 189.019 44.6167C167.622 44.6167 155.098 52.1825 152.229 64.707C151.813 66.6215 151.783 68.5998 152.141 70.5261C152.499 72.4524 153.237 74.2879 154.314 75.9251C159.631 82.3517 182.255 87.9307 208.489 94.3997C244.046 103.168 286.235 113.571 300.949 129.936C308.515 138.286 315.564 151.594 310.605 174.553C308.093 185.672 303.264 196.137 296.433 205.264C289.602 214.39 280.924 221.974 270.964 227.519C219.126 231.136 167.7 239.255 117.268 251.785C12.9034 247.087 14.9881 210.036 22.0369 169.066H124.823C122.21 182.375 122.733 192.031 127.692 198.29C133.145 204.555 141.517 207.946 154.825 207.946C175.699 207.946 199.442 203.249 203.617 183.681C204.033 181.767 204.063 179.788 203.705 177.862C203.347 175.936 202.608 174.1 201.532 172.463C197.033 165.939 173.669 160.143 146.409 153.38C110.439 144.457 67.6886 133.852 52.5504 117.673C41.3434 106.45 41.3434 89.7559 44.2118 75.9251C55.4299 23.7426 108.919 0 204.934 0ZM604.373 6.25556L570.191 166.978H569.407L522.995 6.25556H349.77L334.377 78.0058H359.426L328.09 224.903H341.915C366.181 224.903 390.707 225.687 414.972 227.771L447.07 76.1769H447.848L495.1 236.899C542.651 244.644 589.636 255.54 635.743 269.514H636.527L692.117 6.25L604.373 6.25556ZM632.316 292.23L621.098 346.497C619.014 352.757 613.532 354.063 602.309 350.672C507.072 319.364 393.056 299.012 298.342 299.796C180.668 300.58 48.3861 318.58 15.7713 323.539C-5.62531 327.191 -2.22875 311.014 8.20553 307.623C220.332 231.698 422.019 228.301 632.316 292.23ZM587.13 385.784C542.862 375.006 449.325 352.232 404.798 397.378V397.367C401.14 399.98 398.533 400.764 396.187 399.196C367.756 383.501 337.286 371.823 305.648 364.497C260.7 354.106 215.115 346.698 169.19 342.322C150.406 340.237 154.581 329.797 166.322 326.406C274.873 306.861 472.374 320.169 606.746 373.658C620.571 379.117 617.186 389.551 610.137 390.335C607.175 390.664 598.892 388.647 587.13 385.784Z' stroke='%2300386F' stroke-width='0.5' fill='none'/%3e%3c/svg%3e"
    }))), e.createElement("div", {
      className: Ln.modal_body_container
    }, e.createElement("div", {
      className: Ln.top_row_container
    }, e.createElement("img", {
      src: "data:image/svg+xml,%3csvg width='52' height='34' viewBox='0 0 52 34' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cg id='SN Logo' filter='url(%23filter0_d_121_21466)'%3e%3cpath id='path' d='M29.7343 25.2628C33.3171 21.6301 41.8915 24.9147 42.7884 24.815C43.2366 24.7652 43.4518 24.1018 42.5729 23.7548C34.0303 20.3543 21.4744 19.5082 14.5734 20.7508C13.827 20.9664 13.5616 21.6301 14.7557 21.7626C17.6754 22.0409 20.5734 22.5118 23.4309 23.1724C25.4422 23.6381 27.3793 24.3805 29.1868 25.3783C29.336 25.478 29.5017 25.4282 29.7343 25.2621' fill='%23005EB8'/%3e%3cpath id='path_2' d='M43.4856 22.0282L44.1988 18.5782C30.8294 14.514 18.0074 14.73 4.52166 19.5568C3.85831 19.7724 3.64238 20.8008 5.00265 20.5686C7.07609 20.2534 15.4858 19.109 22.9667 19.0592C28.9881 19.0094 36.2365 20.3032 42.2911 22.2936C43.0046 22.5092 43.3531 22.4261 43.4856 22.0282Z' fill='%23E1251B'/%3e%3cg id='SN'%3e%3cpath id='path_3' d='M42.4218 0.397875L40.2487 10.6156H40.1989L37.2483 0.397875H26.2357L25.2571 4.95931H26.8496L24.8574 14.2981H25.7363C27.279 14.2981 28.8382 14.348 30.3808 14.4805L32.4214 4.84304H32.4709L35.4749 15.0608C38.4979 15.5532 41.4849 16.2459 44.4161 17.1342H44.4659L48 0.397522L42.4218 0.397875Z' fill='white'/%3e%3cpath id='path_4' d='M24.5094 4.95973C25.09 1.80804 23.4976 0 17.0285 0C10.9244 0 7.52389 1.50941 6.81071 4.82685C6.62835 5.70613 6.62835 6.76741 7.34083 7.48095C9.03259 9.28898 16.1488 10.0022 16.8122 10.9641C16.8806 11.0682 16.9276 11.1849 16.9503 11.3074C16.9731 11.4298 16.9712 11.5556 16.9447 11.6773C16.6793 12.9213 15.1699 13.2199 13.8428 13.2199C12.9968 13.2199 12.4645 13.0044 12.1178 12.6061C11.8026 12.2081 11.7694 11.5943 11.9355 10.7482H5.40097C4.95285 13.3528 4.82032 15.7083 11.4552 16.0069C14.6613 15.2104 17.9307 14.6942 21.2262 14.4643C21.8594 14.1117 22.4111 13.6296 22.8454 13.0494C23.2796 12.4692 23.5866 11.8039 23.7464 11.097C24.0616 9.63744 23.6135 8.79138 23.1325 8.26056C21.5068 6.45253 14.6065 5.78918 13.8103 4.82685C13.7419 4.72277 13.6949 4.60608 13.6722 4.48362C13.6494 4.36116 13.6513 4.23539 13.6778 4.11367C13.8601 3.31744 14.6564 2.83645 16.0166 2.83645C16.8129 2.83645 17.4267 2.91951 17.7915 3.28422C18.1894 3.59946 18.3721 4.13028 18.2392 4.95938L24.5094 4.95973Z' fill='white'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cfilter id='filter0_d_121_21466' x='0' y='0' width='52' height='33.4295' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e%3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e%3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha'/%3e%3cfeOffset dy='4'/%3e%3cfeGaussianBlur stdDeviation='2'/%3e%3cfeComposite in2='hardAlpha' operator='out'/%3e%3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0'/%3e%3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_121_21466'/%3e%3cfeBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_121_21466' result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e",
      className: Ln.top_row_logo,
      alt: "SN logo"
    }), e.createElement("div", {
      className: Ln.top_row_buttons
    }, navigator.canShare && navigator.canShare(Ve) && e.createElement("button", {
      className: En(Ln.button, Ln.top_row_button),
      onClick: function onClick() {
        return navigator.share(Ve);
      }
    }, e.createElement("div", {
      className: Ln.share_button
    })), (!navigator.canShare || !navigator.canShare(Ve)) && e.createElement(e.Fragment, null, e.createElement("a", {
      href: "https://www.facebook.com/sharer.php?u=".concat($),
      target: "_blank",
      rel: "noopener noreferrer",
      className: En(Ln.button, Ln.social_button, Ln.facebook)
    }), e.createElement("a", {
      href: "https://x.com/intent/tweet?text=".concat($, "@Sportsnet&url=").concat($),
      target: "_blank",
      rel: "noopener noreferrer",
      className: En(Ln.button, Ln.social_button, Ln.x)
    }), e.createElement("a", {
      href: "https://www.reddit.com/submit?url=".concat($),
      target: "_blank",
      rel: "noopener noreferrer",
      className: En(Ln.button, Ln.social_button, Ln.reddit)
    }), e.createElement("a", {
      href: "mailto:?subject=".concat($),
      target: "_blank",
      rel: "noopener noreferrer",
      className: En(Ln.button, Ln.social_button, Ln.email)
    })), e.createElement("button", {
      className: En(Ln.button, Ln.top_row_button),
      onClick: function onClick() {
        D(!0), setTimeout(function () {
          E(!1), b();
        }, 300);
      }
    }, " ", e.createElement("div", {
      className: Ln.close_button
    })))), e.createElement("div", {
      className: En(Ln.video_container, O && Ln.show_controls)
    }, e.createElement(Ke, {
      attrs: {
        className: Ln.video_player,
        onMouseEnter: function onMouseEnter() {
          return Ie("mouseEnter");
        },
        onMouseLeave: function onMouseLeave() {
          return Ie("mouseLeave");
        },
        onMouseMove: function onMouseMove() {
          return Ie("mouseMove");
        },
        onTouchStart: function onTouchStart() {
          return Ie("touch");
        }
      },
      options: {
        autoplay: l
      },
      accountId: _,
      videoId: oe,
      playerId: f,
      onSuccess: Ne
    })), e.createElement("div", {
      className: Ln.scrollable_container
    }, e.createElement("div", {
      className: Ln.video_info_container
    }, F && e.createElement("h2", {
      className: Ln.video_title
    }, F), !F && e.createElement(In, {
      width: 300,
      height: 25,
      borderRadius: 4,
      opacity: .2,
      marginTop: 4
    }), z && e.createElement("h3", {
      className: Ln.video_subtitle
    }, z), !z && e.createElement(In, {
      width: 240,
      height: 18,
      borderRadius: 4,
      opacity: .2,
      marginTop: 4
    })), e.createElement("div", {
      className: Ln.team_info_sponsor_container
    }, e.createElement("div", {
      className: Ln.teams_container
    }, se && e.createElement("div", {
      className: Ln.team_info_container
    }, se.logo && e.createElement("img", {
      src: se.logo,
      className: Ln.team_logo
    }), e.createElement("div", {
      className: Ln.team_name
    }, se.name), e.createElement("div", {
      className: Ln.button_wrapper
    }, e.createElement(Bn, {
      icon: "favorite",
      invertColors: !0,
      selected: se.favourite,
      onClick: function onClick() {
        return De(se, "first");
      }
    }))), pe && e.createElement("div", {
      className: Ln.team_info_container
    }, pe.logo && e.createElement("img", {
      src: pe.logo,
      className: Ln.team_logo
    }), e.createElement("div", {
      className: Ln.team_name
    }, pe.name), e.createElement("div", {
      className: Ln.button_wrapper
    }, e.createElement(Bn, {
      icon: "favorite",
      invertColors: !0,
      selected: pe.favourite,
      onClick: function onClick() {
        return De(pe, "second");
      }
    })))), e.createElement("div", {
      className: Ln.sponsor_container
    }, y), ae && e.createElement("div", {
      className: Ln.nextup_video_container
    }, e.createElement("div", {
      className: Ln.nextup_text_container
    }, e.createElement("div", {
      className: Ln.nextup_text
    }, "Next up:"), e.createElement("div", {
      className: Ln.nextup_video_title
    }, ae.title)), e.createElement("img", {
      className: Ln.nextup_video_thumbnail,
      src: ae.image_url
    }))), g.length > 0 && e.createElement("div", {
      id: "tags_container",
      className: En(Ln.tags_container, K ? Ln.pinned : null)
    }, g.map(function (n) {
      return e.createElement("div", {
        key: n,
        className: En(Ln.tag, ee.includes(n) ? Ln.selected : null),
        onClick: function onClick() {
          return function (e) {
            ee.includes(e) ? ne(ee.filter(function (n) {
              return n !== e;
            })) : ne([].concat(p(ee), [e]));
          }(n);
        }
      }, n);
    })), e.createElement("div", null, e.createElement(Tn, {
      videos: T,
      playingVideoIndex: G,
      handleVideoClick: function handleVideoClick(e) {
        var n;
        null === (n = M.current) || void 0 === n || n.skipToIndex(parseInt(e)), re(T[e].id), Se();
      },
      adComponent: w,
      showArrows: !0
    }))))) : null;
  };
Pn.propTypes = {
  show: kn.PropTypes.bool,
  autoplay: kn.PropTypes.bool,
  irisClientToken: kn.PropTypes.string,
  videoID: kn.PropTypes.string,
  accountID: kn.PropTypes.string,
  kremerApi: kn.PropTypes.oneOf(["https://int-stats.sportsnet.ca/kremer", "https://staging-stats.sportsnet.ca/kremer", "https://stats.sportsnet.ca/kremer"]),
  playerID: kn.PropTypes.string,
  videoTags: kn.PropTypes.arrayOf(kn.PropTypes.string),
  videoDataFetchUrl: kn.PropTypes.oneOf(["https://int-www.sportsnet.ca/wp-json/data/v1/brightcove", "https://staging-www.sportsnet.ca/wp-json/data/v1/brightcove", "https://www.sportsnet.ca/wp-json/data/v1/brightcove"]),
  sponsorComponent: kn.PropTypes.element,
  adComponent: kn.PropTypes.element,
  onCloseModal: kn.PropTypes.func,
  videoControlsInactivityTimeout: kn.PropTypes.number
}, Pn.defaultProps = {
  show: !1,
  autoplay: !0,
  videoTags: [],
  kremerApi: "https://int-stats.sportsnet.ca/kremer",
  videoDataFetchUrl: "https://www.sportsnet.ca/wp-json/data/v1/brightcove",
  onCloseModal: function onCloseModal() {},
  videoControlsInactivityTimeout: 3e3
};
export { Pn as VideoModal, Pn as default };